<!-- eslint-disable prettier/prettier -->
<!-- eslint-disable prettier/prettier -->
<template>
  <div>
    <el-drawer
      title="Cambio de fecha de pago"
      :append-to-body="true"
      :before-close="handleClose"
      :visible.sync="formpayment"
      size="25%"
    >
      <hr />
      <el-container>
        <el-main>
          <el-row>
            <el-col>
              <el-form
                ref="form"
                label-width="120px"
                v-model="changeDateForm"
                label-position="top"
              >
                <el-form-item label-width="0" label="Contacto">
                  <el-select
                    v-model="changeDateForm.contactCode"
                    v-loading="loadingContacts"
                    placeholder="Contactos"
                    style="width: 100%"
                    @change="getContactNumber"
                  >
                    <el-option
                      style="width: 100%"
                      v-for="item in contacts"
                      :key="item.Code"
                      :label="item.FullName"
                      :value="item.Code"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-row>
                  <!--En caso de que el formatter-->

                  <el-col :span="12">
                    <el-form-item label="Teléfono:">
                      <span v-if="contactPhone"
                        ><a :href="`tel:${contactPhone}`">{{ contactPhone }}</a>
                      </span>
                      <span v-if="changeDateForm.contactCode && !contactPhone">
                        NO DISPONIBLE
                      </span>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="Celular:">
                      <span v-if="contactCellphone"
                        ><a :href="`tel:${contactCellphone}`">{{
                          contactCellphone
                        }}</a></span
                      >
                      <span
                        v-if="changeDateForm.contactCode && !contactCellphone"
                      >
                        NO DISPONIBLE
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label-width="0" label="Fecha Original">
                  <el-date-picker
                    type="date"
                    placeholder="Fecha Original"
                    v-model="changeDateForm.currentdate"
                    disabled
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item label-width="0" label="Nueva Fecha">
                  <el-date-picker
                    type="date"
                    placeholder="Nueva Fecha"
                    v-model="changeDateForm.newdate"
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item label-width="0" label="Comentario">
                  <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="Comentario respecto al cambio de fecha de pago"
                    v-model="changeDateForm.comment"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button
                    type="primary"
                    @click="onSubmit"
                    :disabled="!isValid"
                    size="mini"
                    >Guardar cambios</el-button
                  >
                  <el-button @click="handleClose" size="mini"
                    >Cancelar</el-button
                  >
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-drawer>

    <el-drawer
      title="Comentarios"
      :visible.sync="comments"
      :append-to-body="true"
      size="60%"
    >
      <el-container>
        <el-main>
          <el-row>
            <el-col>
              <rabbey-table3
                ref="table2"
                :columns="columnsComments"
                v-loading="loadingDetails"
                :before-close="handleClose"
                :data="commentList"
              />
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-drawer>

    <el-dialog
      :visible.sync="isVisible"
      :show-close="closeDialogSeller"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="OnCoclose"
      :lock-scroll="true"
      :modal="true"
      center
      width="65%"
    >
      <span slot="title" class="title-container">
        {{ DialogTitle }}
      </span>
      <!--@closed="OnCoclose"-->
      <!-- <el-alert
        title="ATENCIÓN"
        description="Para continuar usando Magynet favor de aprobar / calificar todo lo que tiene pendiente."
        type="info"
        :closable="false"
        show-icon
      >
      </el-alert> -->
      <!--
        <h3>
          Para continuar usando Magynet favor de realizar todo lo que pendiente a
          continuación (aprobaciones, calificaciones o promesas de pago).
        </h3>
        -->
      <el-row
        class="rowHeader"
        v-if="DialogTitle === 'Cobros sin promesa de pagos'"
      >
        <el-col :span="10">
          <el-row class="internalRowHeader">
            <el-col :span="13">
              <p>Total Facturas Sin Fecha de pagos:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong v-if="collectionsFilter == 0">{{
                  billsWithoutPaymentDate
                }}</strong>
                <strong v-if="collectionsFilter == 1">{{
                  TotalUnexpiredAmountCount
                }}</strong>
                <strong v-if="collectionsFilter == 2">{{
                  TotalExpiredAmountCount
                }}</strong>
              </p>
            </el-col>
          </el-row>
          <el-row class="internalRowHeader">
            <el-col :span="13">
              <p>Total monto Sin Fecha de pagos:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong v-if="collectionsFilter == 0">{{
                  TotalAmountWithoutPaymentDate
                }}</strong>
                <strong v-if="collectionsFilter == 1">{{
                  TotalUnexpiredAmount
                }}</strong>
                <strong v-if="collectionsFilter == 2">{{
                  TotalExpiredAmount
                }}</strong>
              </p>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="10">
          <el-row class="internalRowHeader">
            <el-col :span="12">
              <p>Total Montos Vencidos:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong>{{
                  collectionsFilter == 0 || collectionsFilter == 2
                    ? TotalExpiredAmount
                    : 0
                }}</strong>
              </p>
            </el-col>
          </el-row>
          <el-row class="internalRowHeader">
            <el-col :span="12">
              <p>Total monto Al dia:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong>{{
                  collectionsFilter == 0 || collectionsFilter == 1
                    ? TotalUnexpiredAmount
                    : 0
                }}</strong>
              </p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row
        class="rowHeader"
        v-if="
          DialogTitle === 'Facturas del mes sin registrar' ||
          DialogTitle === 'Facturas sin registrar meses anteriores'
        "
      >
        <el-col :span="10">
          <el-row class="internalRowHeader">
            <el-col :span="13">
              <p>Total a pagar:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong>{{ totalInvoices }}</strong>
              </p>
            </el-col>
          </el-row>

          <!-- <el-row class="internalRowHeader">
            <el-col :span="13">
              <p>Pagado:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong>{{ totalPaymentsRecorded }}</strong>
              </p>
            </el-col>
          </el-row> -->
        </el-col>
        <el-col :span="10">
          <el-row class="internalRowHeader">
            <el-col :span="12">
              <p>Pendiente:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong>{{ totalInvoicesNotRecorded }}</strong>
              </p>
            </el-col>
          </el-row>
          <el-row class="internalRowHeader">
            <el-col :span="12">
              <p>Total Vencidos:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong>{{ totalOverdueInvoices }}</strong>
              </p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="rowHeader" v-if="DialogTitle === 'Documentos del cliente'">
        <el-col :span="16">
          <el-select v-model="selectedClient" placeholder="Cliente estatus">
            <el-option
              v-for="item in selectedStatusClient"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <p style="font-size: 1.2rem;"> Clientes con contratos adjuntos: <strong> {{onTableData.filter(x => x.Contratos > 0).length}} </strong> </p>
          <p style="font-size: 1.2rem;"> Clientes sin contratos adjuntos: <strong> {{onTableData.filter(x => x.Contratos == 0).length}} </strong> </p>
        </el-col>
      </el-row>

      <el-row
        class="rowHeader"
        v-if="
          DialogTitle === 'Pagos del mes sin realizar' ||
          DialogTitle === 'Pagos pendientes meses anteriores'
        "
      >
        <el-col :span="10">
          <el-row class="internalRowHeader">
            <el-col :span="13">
              <p>Total a pagar:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong>{{ totalPayments }}</strong>
              </p>
            </el-col>
          </el-row>

          <el-row class="internalRowHeader">
            <el-col :span="13">
              <p>Pagado:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong>{{ totalPaymentsRecorded }}</strong>
              </p>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="10">
          <el-row class="internalRowHeader">
            <el-col :span="12">
              <p>Sin pagar:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong>{{ totalPaymentsNotRecorded }}</strong>
              </p>
            </el-col>
          </el-row>

          <el-row class="internalRowHeader">
            <el-col :span="12">
              <p>Total Vencidos:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong>{{ totalOverduePayment }}</strong>
              </p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row
        class="rowHeader"
        v-if="DialogTitle === 'Clientes sin Portal y sin APP'"
      >
        <el-row class="internalRowHeader">
          <el-col :span="7">
            <el-row class="internalRowHeader">
              <el-col :span="11">
                <p>Clientes Sin Portal:</p>
              </el-col>
              <el-col :span="5">
                <p>
                  <strong>{{ TotalClientsWithoutPortal }}</strong>
                </p>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="7">
            <el-row class="internalRowHeader">
              <el-col :span="11">
                <p>Clientes Sin APP:</p>
              </el-col>
              <el-col :span="5">
                <p>
                  <strong>{{ TotalClientsWithoutApp }}</strong>
                </p>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="7">
            <el-row class="internalRowHeader">
              <el-col :span="11">
                <p>Clientes Sin APP y Portal:</p>
              </el-col>
              <el-col :span="5">
                <p>
                  <strong>{{ TotalClientsWithoutAppAndPortal }}</strong>
                </p>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-tooltip
            class="collectionsFilterToltip collectionsFilter"
            effect="light"
            content="Filtro Clientes Sin App o Portal"
            placement="top"
          >
            <el-select
              v-model="clientsPortalAppFilter"
              placeholder="Filtro Clientes Sin App o Portal"
              size="mini"
              class="collectionsFilter"
            >
              <el-option
                v-for="item in clientsPortalAppFilteroptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-tooltip>
          <el-tooltip
            class="collectionsFilterToltip collectionsFilter"
            effect="light"
            content="Filtro Clientes por Servicio al Cliente"
            placement="top"
          >
            <CustomerServiceSelector
              v-model="customersServicefilter"
              @customerServiceSelected="handleCustomerServiceChange"
            />
          </el-tooltip>
        </el-row>
      </el-row>
      <el-row>
        <el-select
          v-model="valueGPS"
          placeholder="Select"
          size="small"
          clearable
          v-if="DialogTitle === 'GPSs Fuera de Linea'"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <yearcomponent
          @change="handler_year"
          v-model="year"
          v-if="DialogTitle === 'Facturas del mes sin registrar'"
          class="collectionsFilter"
        >
        </yearcomponent>
        <monthcomponent
          @change="handler_month"
          v-model="month"
          v-if="DialogTitle === 'Facturas del mes sin registrar'"
          class="collectionsFilter marginRight"
        >
        </monthcomponent>
        <!--select de cobros sin promesa de pagos-->
        <el-tooltip
          class="collectionsFilterToltip"
          effect="light"
          content="Filtro de cobros"
          placement="left-start"
        >
          <el-select
            v-model="collectionsFilter"
            placeholder="Filtro de cobros vencidos"
            v-if="DialogTitle === 'Cobros sin promesa de pagos'"
            size="small"
            class="collectionsFilter"
          >
            <el-option
              v-for="item in collectionsFilteroptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-tooltip>
      </el-row>
      <el-row
        class="rowHeader"
        v-if="
          DialogTitle === 'Tareas retrasadas' &&
          IsInRoles([roles.CEO]) &&
          currentUser.PositionID == 16
        "
        :gutter="24"
        style="display: flex; justify-content: space-between"
      >
        <el-col :span="8">
          <p v-if="employeeId !== 0 || directionId !== 0 || supervisorId !== 0">
            <strong> Total: {{ onTableData.length }}</strong>
          </p>
        </el-col>

        <el-col :span="16" style="display: flex; justify-content: flex-end">
          <EmployeeSelector
            placeholder="Empleados"
            v-model="employeeId"
            @selection-change="updateSelectedEmployee"
            @list-employee="employeList = $event"
          />
          <DirectionSelector
            v-model="directionId"
            @selection-change="handleChangeDirection"
          />

          <EmployeeSelector
            placeholder="Supervisores"
            :onlySupervisor="true"
            v-model="supervisorId"
            @selection-change="handleChangeSupervisor"
            @list-employee="employeList = $event"
          />
        </el-col>
      </el-row>

      <iframe
        v-if="DialogTitle === 'Encuestas'"
        :src="encuestalink"
        title="W3Schools Free Online Web Tutorials"
        style="width: 100%; height: 600px"
      ></iframe>

      <!-- <el-row class="rowHeader" v-if="DialogTitle === 'Documentos de clientes'">
        <rabbey-table-3
          :data="onTableData"
          :columns="Columns"
          :loading="loading"
          :maxheight="500"
          :actions="Actions"
          @rtable-push-action="actionHandlerHelper"
          :stripe="true"
          v-if="Columns.length != 0"
        />
      </el-row> -->

      <rabbey-table-3
        :data="onTableData"
        :columns="Columns"
        :loading="loading"
        :actions="Actions"
        :maxheight="500"
        @rtable-push-action="actionHandlerHelper"
        :stripe="true"
        v-if="Columns.length != 0"
      />
      <el-row type="flex" justify="end" align="bottom">
        <!--
          v-loading="SaveButtonLoading"
        -->
        <el-button
          style="margin-top: 30px"
          size="mini"
          type="primary"
          v-loading="SaveButtonLoading"
          @click="updateProjectDetailLine"
          v-if="saveButtonVisible && TableData.some((d) => d.Excetuted == true)"
          >Guardar
        </el-button>
      </el-row>
      <el-row
        v-show="
          isDevEnv === true ||
          (currentUser.Roles.some((user) => user.Id === 13) &&
            currentUser.UserID !== 10)
        "
        style="margin-bottom: 0px"
      >
        <el-divider></el-divider>
        <el-button type="info" size="mini" @click="nextDialog">
          saltar dialogo</el-button
        >
        <p style="padding-bottom: 0px">
          Este boton provicional de saltar dialogo solo existe en el entorno de
          desarrollo, no en QA, ni en Produccion
        </p>
      </el-row>

      <!-- contratos vencidos - renovar contrato-->
      <ContractsRenovationDialog
        :dialogVisible="dialogVisible"
        :key="ContractsRenovationKey"
        :currentActionData="currentActionData"
        @DataSubmited="GetDetailsData"
      />
      <!-- contratos vencidos - ver lista de lineas de contratos del contrato seleccionado-->
      <contractDetails ref="details" :appendToBoddy="true" />

      <!-- Oportunidades vencidas     -->
      <DealsFormDrawer
        ref="form_view"
        :title="dealDetailTitle"
        :drawer.sync="dealDetailDrawer"
        :loading="true"
        :append-to-body="true"
        v-bind="dealDetailBind"
        @close-drawer="CloseDetailDrawer"
        @refresh-table="handleTableUpdate"
      />

      <!-- AutoMVs por calificar -->
      <ViewAutoMvForm
        :openAutoMVView="openAutoMVView"
        :AutoMVFormModel="DataAutoMVFormModel"
        :TasktableDataEstrategico="TasktableDataEstrategico"
        :TasktableDataOperacional="TasktableDataOperacional"
        :totalTaksClosedOnTimeEstrategico="
          totalTaksClosedOnTimeEstrategico.length
        "
        :totalTaksClosedOnTimeOperacional="
          totalTaksClosedOnTimeOperacional.length
        "
        :totalTaksClosedOnLateEstrategicoo="
          totalTaksClosedOnLateEstrategico.length
        "
        :totalTaksClosedOnLateOperacional="
          totalTaksClosedOnLateEstrategico.length
        "
        :totalTaksOpenOnTimeEstrategico="totalTaksOpenOnTimeEstrategico.length"
        :totalTaksOpenOnTimeOperacional="totalTaksOpenOnTimeOperacional.length"
        :totalTaksOpenOnLateEstrategico="totalTaksOpenOnLateEstrategico.length"
        :totalTaksOpenOnLateOperacional="totalTaksOpenOnLateOperacional.length"
        :taskOpenOnLateOnWeekEstrategico="
          taskOpenOnLateOnWeekEstrategico.length
        "
        :taskOpenOnLateOnWeekOperacional="
          taskOpenOnLateOnWeekOperacional.length
        "
        :percetangeWeekEstrategico="percetangeWeekEstrategico"
        :percetangeWeekOperacional="percetangeWeekOperacional"
        :percetangeTotalEstrategico="percetangeTotalEstrategico"
        :percetangeTotalOperacionall="percetangeTotalOperacional"
        :isSupervisor="isSupervisor"
        @onClose="closeAutoMVView"
        @refresh-table="refreshTableSuccessAutoMV"
        :taksOpenOnTimeOperacional="taksOpenOnTimeOperacional.length"
        :taskCloseOnLateOnWeekOperacional="
          taskCloseOnLateOnWeekOperacional.length
        "
        :taksClosedOnTimeOperacional="taksClosedOnTimeOperacional.length"
        :taksClosedOnTimeEstrategico="taksClosedOnTimeEstrategico.length"
        :taksOpenOnTimeEstrategico="taksOpenOnTimeEstrategico.length"
        :taskCloseOnLateOnWeekEstrategico="
          taskCloseOnLateOnWeekEstrategico.length
        "
        :createdAt="createdAtt"
        :loadingFormItem="loading"
      />

      <!-- Solicitudes vencidas -->
      <request-form ref="form" />

      <DialogCommentOnLate
        :openDialog="DialogCommentOnLateOpen"
        :requesId="RequestIdDialog"
        @close-dialog="DialogCommentOnLateOpen = false"
        @refresh-table="refreshTableSuccessRequestsOnLate"
      />

      <dialog-new-interaction-form
        :CustomerData="CustomerData"
        ref="dialogNewInteraction"
      />

      <!-- @update-table="updateTableData" -->
      <TaskForm
        ref="taskFormDrawer"
        :append-to-body="true"
        :visible.sync="taskDrawer"
        :currentActionSelected="currentActionSelected"
        @update-data="onPushAction(actionRowData)"
        @update-table="getFreshTask"
      ></TaskForm>
      <!--:currentActionSelected="currentActionSelected"
      currentActionForDelayedTask="tranque"-->

      <!--drawer para ver el detalle de la solicitud a calificar  -->
      <InternalRequestDrawer
        :drawer.sync="showDetailRate"
        :data="detailDataRate"
        :append-to-body="true"
        :modal="false"
        @InternalRequestDrawerClose="closeInternalRequestDrawer"
      />

      <RecordRatingVue
        ref="record_rating"
        @rating-success="refreshTableSuccess"
      />

      <!--drawer para ver el detalle de la solicitud a calificar  -->
      <RequestForm ref="form" :open="true" />

      <!--drawer para ver el detalle de la nueva solicitud a asignar-->
      <InternalRequestDrawer
        :key="InternalRequestDrawerKey"
        :drawer.sync="showDetail"
        :data="detailData"
        :append-to-body="true"
        :modal="false"
        @InternalRequestDrawerClose="closeInternalRequestDrawer"
      />

      <ChangePostingDateAndAmount
        ref="changePostingDate"
        @success="onChangePDSuccess"
        @error="refresh"
      />

      <!--Dialogo Nueva soicitud Interna-->
      <NewFormRequest ref="NewFormRequest" :ResquestObject="PaymentResquest" />

      <!--Dialogo creacion Nueva soicitud Externa-->
      <dialog-new-request-form ref="dialogNewRequest" />

      <!--Dialogo creacion Nueva iteracion al cliente-->
      <dialog-new-interaction-form
        :CustomerData="CustomerData"
        :appendToBoddy="true"
        ref="dialogNewInteraction"
      />

      <dialog-new-request-form
        ref="dialogNewRequestForContractCancelation"
        :key="NewResquestFormKey"
        :Desinstalacion="true"
        @Formsubmitted="OnFormsubmitted"
        Adjunto="Adjuntar Documento de Cancelacion con Autorizacion del cliente: "
      />

      <ContractCancellationWarning
        :ConfimrContractCancellationView="ConfimrContractCancelView"
        :CurrentActionData="currentActionData"
        @onContractCancelationConfirmation="onContractCancelationConfirmation"
        @onDialogContractCancelationClose="OnContractCancelationClose"
      />

      <!--Detalle de contactos con o sin app o portal para card emergete de Clientes sinportal y sin app-->
      <ReportAppCustomerServiceDetail ref="AppCostumerServiceDetail" />

      <!-- DIALOG DE CAMBIO DE FECHA en cashflow project -->
      <el-dialog
        :title="`Editar Ingreso o Egreso`"
        :visible.sync="changeDateDiaglog"
        :append-to-body="true"
        width="30%"
      >
        <!-- :before-close="handleCloseProviderDialog" -->
        <el-form>
          <el-form-item label="Nota">
            <el-input disabled v-model="updatedLine.Description" />
          </el-form-item>

          <el-form-item label="Monto">
            <el-input v-model="updatedLine.Amount" />
          </el-form-item>

          <el-form-item label="Nueva Fecha">
            <el-date-picker
              type="date"
              placeholder="Nueva Fecha de Ingreso"
              v-model="updatedLine.PostinDate"
              style="width: 100%"
            />
          </el-form-item>
        </el-form>
        <el-button
          type="primary"
          v-loading="SaveButtonLoading"
          @click="updateLine"
        >
          Guardar Cambios
        </el-button>
      </el-dialog>

      <!--dialogo para asignar responsable de solicitud o para agregar comentario a solicitud, este ultimo no funciona-->
      <el-dialog
        width="30%"
        :title="dialog.title"
        :visible.sync="dialog.visible"
        :before-close="handleCloseDialog"
        :append-to-body="true"
        class=""
      >
        <!--:before-close="handleCloseDialog"-->
        <el-form ref="form" :model="dialog" :rules="rules[dialog.type]">
          <el-form-item v-if="dialog.type === 'set'" prop="responsableId">
            <el-select
              v-model="dialog.responsableId"
              placeholder="Seleccion tipo de solicitud"
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="(resp, index) in employeList"
                :key="index"
                :value="resp.value"
                :label="resp.label"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="dialog.type === 'addComment'" prop="comment">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="Agrega tu comentario"
              v-model="dialog.comment"
            >
            </el-input>
          </el-form-item>

          <el-form-item
            v-if="dialog.type === 'addcommentReasonToReopen'"
            prop="commentReasonToReopen"
            :rules="[
              {
                required: true,
                message:
                  'Debes de agregar el comentario del porque se debe Reabrir la solicitud',
                trigger: 'blur'
              }
            ]"
          >
            <el-input
              type="textarea"
              :rows="2"
              placeholder="Agrega tu comentario del porque se debe 'Reabrir la solicitud'"
              v-model="dialog.commentReasonToReopen"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelDialog">Cancel</el-button>
          <el-button type="primary" @click="confirmDialog">Confirm</el-button>
        </span>
      </el-dialog>

      <EditEventFinances
        :openEditEvent="openEditEvent"
        :dataInvoices="dataInvoices2"
        :dialogTitleEvent="DialogTitle"
        @onClose="closeEditEventFinances"
      ></EditEventFinances>
    </el-dialog>
  </div>
</template>

<script>
import EditEventFinances from "@/views/apps/calendar/EditEventFinances.vue";
import DialogCommentOnLate from "@/views/modules/technical_support/requests/DialogCommentOnLate.vue";
import RequestForms from "@/views/modules/technical_support/requests/RequestForm.vue";
import ViewAutoMvForm from "@/views/apps/cmi/AutoMvs/ViewForm/ViewAutoMvForm.vue";
import TaskForm from "@/views/apps/cmi/objetives/TaskForm.vue";
import {
  dialog,
  showDetail,
  detailData
} from "@/components/activity_flow/DialogLocker/InternalRequestsPendingAssignment.js";

import ContractsRenovationDialog from "@/components/activity_flow/CustomerServiceStat/ContractsRenovationDialog.vue";
import contractDetails from "@/components/customers/TableContractsDetails.vue";
import {
  // dialog,
  showDetailRate,
  detailDataRate
} from "@/components/activity_flow/DialogLocker/RequestPendingToRate.js";
import InternalRequestDrawer from "@/components/internal_requests/InternalRequestDrawer.vue";
import { formatArrayToElSelect } from "@/utils";
import {
  GetInternalRequestWithoutAssigment /*,
  InternalRequestColumns,
  InternalRequestActions,
  InternalRequestActionHandler*/
} from "@/components/activity_flow/DialogLocker/InternalRequestsPendingAssignment.js";

import { getDelayedTasks } from "@/components/activity_flow/DialogLocker/DelayedTask.js";

import { ContractsPaymentgetTableData } from "@/components/activity_flow/DialogLocker/contractsPending.js";
import { OportunityPaymentgetTableData } from "@/components/activity_flow/DialogLocker/PendingOportunity.js";
import DealsFormDrawer from "@/components/deals/DealsFormDrawer.vue";
import Deal from "@/models/deals/Deal";
import { commentColumns } from "@/helpers/MonthsColumns";
import { formatPhoneNumber, formatMonto } from "@/utils";
import RecordRatingVue from "../requests/RecordRating.vue";
import { QuealifyGetTableData } from "@/components/activity_flow/DialogLocker/RequesPendingCalific.js";
import { GetAutoMVsPendingCalific } from "@/components/activity_flow/DialogLocker/AutoMVsPendingCalific.js";
import RequestForm from "@/views/modules/technical_support/requests/RequestForm.vue";
import { GetRequestOnLate } from "@/components/activity_flow/DialogLocker/GetRequestOnLate.js";
import {
  GetExpiredAccsWithoutExecution
  /*
  ExpiredAccsWithoutExecutionColumns,
  ExpiredAccsWithoutExecutionActions,
  ExpiredAccsWithoutExecutionActionHandler
  */
} from "@/components/activity_flow/DialogLocker/ExpiredAccWithoutExcutionCF.js";
import ChangePostingDateAndAmount from "@/views/modules/projects/components/ChangePostingDateAndAmount.vue";
import { GetProjectExpiredAccsWithoutExecution } from "@/components/activity_flow/DialogLocker/ExpiredAccWithoutExcutionPCF.js";
import NewFormRequest from "@/components/requests/NewRequestForm.vue";
import ReportAppCustomerServiceDetail from "@/components/customer_service/reports/ReportAppCustomerServiceDetail.vue";
import CustomerServiceSelector from "@/components/Company/CustomerServiceSelector.vue";
import EmployeeSelector from "../Company/EmployeeSelector.vue";
import DirectionSelector from "../Company/DirectionSelector.vue";
import { /*mapGetters,*/ mapActions } from "vuex";
import ContractCancellationWarning from "@/components/customer_service/Contracts/ContractCancellationWarning.vue";
import yearcomponent from "@/components/Global_System/YearsComponent.vue";
import monthcomponent from "@/components/Global_System/MonthsComponent.vue";

// import { string } from "yargs";
export default {
  components: {
    TaskForm,
    InternalRequestDrawer,
    ContractsRenovationDialog,
    contractDetails,
    DealsFormDrawer,
    RecordRatingVue,
    ViewAutoMvForm,
    "request-form": RequestForms,
    DialogCommentOnLate,
    RequestForm,
    ChangePostingDateAndAmount,
    NewFormRequest,
    ReportAppCustomerServiceDetail,
    EditEventFinances,
    CustomerServiceSelector,
    EmployeeSelector,
    DirectionSelector,
    ContractCancellationWarning,
    yearcomponent,
    monthcomponent,
    "dialog-new-request-form": () =>
      import(
        /* webpackChunkName: "DialogNewRequestForm" */ "@/components/requests/DialogNewRequestForm.vue"
      ),
    "dialog-new-interaction-form": () =>
      import(
        /* webpackChunkName: "DialogNewInteractionForm" */ "@/components/interactions/DialogNewInteractionForm.vue"
      )
  },
  props: {
    DialogTitle: {
      type: String,
      default: ""
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    TableData: {
      type: Array,
      default: () => []
    },
    Columns: {
      type: Array,
      default: () => []
    },
    Actions: {
      type: Array,
      default: () => []
    },
    ActionHandler: {
      type: Function,
      default: () => {}
    },
    all: {
      type: Boolean,
      required: false
    },
    TableLoading: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      // opciones del filtro de gps fuera de linea
      options: [
        {
          value: 1,
          label: "1 a 7 dias"
        },
        {
          value: 2,
          label: "7 a 15 dias"
        },
        {
          value: 3,
          label: "15 a 30 dias"
        },
        {
          value: 4,
          label: "más de 30 dias"
        },
        {
          value: 0,
          label: "Todos"
        }
      ],
      valueGPS: 0,
      //opciones del filtro de cobros sin promesa de pagos
      collectionsFilteroptions: [
        {
          value: "2",
          label: "pagos vencidos"
        },
        {
          value: "1",
          label: "Pagos al dia"
        },
        {
          value: "0",
          label: "Todos"
        }
      ],
      collectionsFilter: "2",
      clientsPortalAppFilteroptions: [
        {
          value: 3,
          label: "Clientes sin App y Portal"
        },
        {
          value: 2,
          label: "Clientes sin App"
        },
        {
          value: 1,
          label: "Clientes sin Portal"
        },
        {
          value: 0,
          label: "Todos los clientes"
        }
      ],
      clientsPortalAppFilter: 0,
      customersServicefilter: "",
      customerServiceSelected: "",
      close: false,
      loading: true,
      taskDrawer: false,
      dialog,
      showDetail: false,
      actions: [],
      detailData,
      CustomerData: {},
      currentActionSelected: "",
      dialogVisible: false,
      ContractsRenovationKey: 0,
      ConfimrContractCancelView: false,
      //isCancelationConfirmed: false,
      encuestaUrlBase: "",
      encuestalink: "",
      StatusContract: "",
      NewResquestFormKey: Math.floor(Math.random() * 1000) + 1,
      currentActionData: {},
      CustomersList: [],
      page: 1,
      limit: 1000000,
      totalItems: 0,
      CustomerSearch: null,
      cxc_filter: "",
      status_filter: "",
      seller_filter: "",
      customers_filter: "",
      customer_clasification: "",
      customer_type: "",
      items: [],
      index: [],
      showDetailRate: false,
      detailDataRate,
      InternalRequestDrawerKey: 1,
      // Props Oportunidades vencidas
      dealDetailDrawer: false,
      dealDetailTitle: "",
      DealsLoading: false,
      dealDetailBind: {
        initModel: Deal
      },
      //props promesas vencidas
      commentList: [],
      changeDateForm: {
        currentdate: "",
        newdate: "",
        comment: "",
        contactCode: ""
      },
      EntryNoIndex: "",
      formpayment: false,
      comments: false,
      loadingContacts: false,
      loadingDetails: false,
      columnsComments: [...commentColumns],
      Amount: 0,
      AccountNumber: 0,
      invoiceNum: 0,
      OldDate: "",
      contactPhone: 0,
      contactCellphone: 0,
      contacts: [],
      closeDialogSeller: true,
      //Solicitudes por calificar
      ratedRequestIndex: "",
      visible: false,
      isDevEnv: false,
      employeeId: 0,
      directionId: 42,
      supervisorId: 0,

      //solicitudes vencidas
      DialogCommentOnLateOpen: false,
      RequestIdDialog: 0,

      //AutoMVs por calificar
      openAutoMVView: false,
      isSupervisor: false,
      DataAutoMVFormModel: {},
      // TasktableData: [],
      // totalTaksClosedOnTime: [],
      // totalTaksClosedOnLate: [],
      // totalTaksOpenOnTime: [],
      // totalTaksOpenOnLate: [],
      // taskCloseOnLateOnWeek: [],
      // taskOpenOnLateOnWeek: [],
      TasktableDataOperacional: [],
      TasktableDataEstrategico: [],
      totalTaksClosedOnTimeOperacional: [],
      totalTaksClosedOnTimeEstrategico: [],
      totalTaksClosedOnLateOperacional: [],
      totalTaksClosedOnLateEstrategico: [],
      totalTaksOpenOnTimeOperacional: [],
      totalTaksOpenOnTimeEstrategico: [],
      totalTaksOpenOnLateOperacional: [],
      percetangeWeekOperacional: 0,
      percetangeTotalOperacional: 0,
      totalTaksOpenOnLateEstrategico: [],
      taskOpenOnLateOnWeekOperacional: [],
      taskOpenOnLateOnWeekEstrategico: [],

      TasktableData: [],

      totalTaksClosedOnTime: [],
      totalTaksClosedOnLate: [],
      totalTaksOpenOnTime: [],
      totalTaksOpenOnLate: [],
      taskCloseOnLateOnWeek: [],
      taskCloseOnLateOnWeekOperacional: [],
      taskCloseOnLateOnWeekEstrategico: [],
      taksClosedOnTimeOperacional: [],
      taksOpenOnTimeOperacional: [],
      taskOpenOnLateOnWeek: [],
      taksOpenOnTimeEstrategico: [],
      taksClosedOnTimeEstrategico: [],
      percetangeWeekEstrategico: 0,
      percetangeTotalEstrategico: 0,
      createdAtt: "",

      saveButtonVisible: false,
      SaveButtonLoading: false,
      changeDateDiaglog: false,
      updatedLine: {},
      PaymentResquest: {
        DirectionId: 0,
        ResquestTypeId: 0
      },
      openEditEvent: false,
      //OBJETO DATA FACTURAS
      dataInvoices2: {},
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      // InternalRequestDrawerKeyRate: 3,
      employeList: [],
      rules: {
        set: {
          responsableId: [
            {
              required: true,
              message: "Debe indicar el responsable",
              trigger: "blur"
            }
          ]
        },
        addComment: {
          comment: [
            {
              required: true,
              message: "Debe introducir un comentario",
              trigger: "blur"
            },
            {
              min: 3,
              message: "Length should be 3",
              trigger: "blur"
            }
          ]
        }
      },
      selectedStatusClient: [
        {
          value: 0,
          label: "Todos"
        },
        {
          value: 1,
          label: "Activos"
        },
        {
          value: 2,
          label: "Inactivos"
        }
      ],
      selectedClient: 0
    };
  },
  created() {
    if (this.$store.state.interactions.list.length <= 0) {
      this.$store.dispatch("interactions/all");
    }

    if (this.$store.state.interactions.list_interaction_code.length <= 0) {
      this.$store.dispatch("interactions/get_interaction_code");
    }

    if (this.$store.state.products.list.length <= 0) {
      this.$store.dispatch("products/all");
    }

    if (this.$store.state.request_types.list.length <= 0) {
      this.$store.dispatch("request_types/all");
    }
    // this.$refs.InternalRequest.getItems();
    this.closeDialogSeller = false;
    //TableDataGPS = this.TableData;
    if (process.env.NODE_ENV === "development") {
      this.isDevEnv = true;
    } else {
      this.isDevEnv = false;
    }
  },
  mounted() {
    // this.$refs.yearC.Year = this.year;
    window.addEventListener("message", this.handleIframeMessage);
  },
  computed: {
    onTableData() {
      if (this.DialogTitle === "GPSs Fuera de Linea") {
        if (this.valueGPS === 1) {
          let filteredOfflineTrackers = this.TableData.filter(
            (offtrack) => offtrack.daysOffline > 0 && offtrack.daysOffline <= 7
          );
          return filteredOfflineTrackers;
        }
        if (this.valueGPS === 2) {
          let filteredOfflineTrackers = this.TableData.filter(
            (offtrack) => offtrack.daysOffline > 7 && offtrack.daysOffline <= 15
          );
          return filteredOfflineTrackers;
        }
        if (this.valueGPS === 3) {
          let filteredOfflineTrackers = this.TableData.filter(
            (offtrack) =>
              offtrack.daysOffline > 15 && offtrack.daysOffline <= 30
          );
          return filteredOfflineTrackers;
        }
        if (this.valueGPS === 4) {
          let filteredOfflineTrackers = this.TableData.filter(
            (offtrack) => offtrack.daysOffline > 30
          );
          return filteredOfflineTrackers;
        } else {
          return this.TableData;
        }
      } else if (this.DialogTitle === "Cobros sin promesa de pagos") {
        let collectionsFiltered;
        //console.log(this.TableData);
        switch (this.collectionsFilter) {
          case "0":
            //console.log(this.collectionsFilter);
            collectionsFiltered = this.TableData;
            break;

          case "1":
            //console.log(this.collectionsFilter);
            collectionsFiltered = this.TableData.filter(
              (td) => td.NumberOfDaysOverDue === 0
            );
            break;
          case "2":
            //console.log(this.collectionsFilter);
            collectionsFiltered = this.TableData.filter(
              (td) => td.NumberOfDaysOverDue > 0
            );
            break;

          default:
            //console.log(this.collectionsFilter);
            collectionsFiltered = this.TableData;
            break;
        }
        return collectionsFiltered;
      } else if (this.DialogTitle === "Facturas del mes sin registrar") {
        let yearandmonthfiltered;
        yearandmonthfiltered = this.TableData.filter((td) => {
          let [yearF, monthF] = td.BillingDate.split("-");
          return monthF == this.month && yearF == this.year;
        });
        return yearandmonthfiltered;
      } else if (this.DialogTitle === "Clientes sin Portal y sin APP") {
        let ClientsAppPortalFiltered;

        //console.log("customersServicefilter: ",this.customersServicefilter);
        switch (this.clientsPortalAppFilter) {
          case 0:
            //console.log(this.collectionsFilter);
            ClientsAppPortalFiltered = this.TableData;
            break;

          case 1:
            //console.log(this.collectionsFilter);
            ClientsAppPortalFiltered = this.TableData.filter(
              (client) => client.CantContactPortalWebInactive > 0
            );
            break;
          case 2:
            //console.log(this.collectionsFilter);
            ClientsAppPortalFiltered = this.TableData.filter(
              (client) => client.CantContactsWithoutApp > 0
            );
            break;

          case 3:
            //console.log(this.collectionsFilter);
            ClientsAppPortalFiltered = this.TableData.filter(
              (client) =>
                client.CantContactsWithoutApp > 0 &&
                client.CantContactPortalWebInactive > 0
            );
            break;

          default:
            //console.log(this.collectionsFilter);
            ClientsAppPortalFiltered = this.TableData;
            break;
        }
        if (this.customerServiceSelected !== "") {
          return ClientsAppPortalFiltered.filter(
            (client) =>
              client.CustomerServiceCode === this.customerServiceSelected
          );
        }
        /*
        else {
          ClientsAppPortalFiltered = this.TableData;
        }
        */
        return ClientsAppPortalFiltered; //.filter(client => client.CustomerServiceCode == this.customersServicefilter);
      } else if (this.DialogTitle === "Tareas retrasadas") {
        // if (this.employeeId === 0) return this.TableData;
        let filterByEmployeer = this.TableData;

        if (this.employeeId !== 0) {
          filterByEmployeer = filterByEmployeer.filter(
            (employee) => employee.ResponsableId == this.employeeId
          );
        }

        if (this.directionId !== 0) {
          filterByEmployeer = filterByEmployeer.filter(
            (employee) => employee.DirecctionId == this.directionId
          );
        }

        if (this.supervisorId !== 0) {
          filterByEmployeer = filterByEmployeer.filter(
            (employee) => employee.SupervisorID == this.supervisorId
          );
        }

        return filterByEmployeer;
      } else if (this.DialogTitle === "Documentos del cliente") {
        var documentClient = this.TableData;

        console.log("Llegue", this.TableData);
        switch (this.selectedClient) {
          case 0:
            documentClient = this.TableData;
            break;
          case 1:
            documentClient = this.TableData.filter(
              (client) => client.ContractStatus === 1
            );
            break;
          case 2:
            documentClient = this.TableData.filter(
              (client) => client.ContractStatus === 0
            );
            break;
          default:
            documentClient = this.TableData;
        }

        // this.contractAct = this.TableData.length;

        return documentClient;
      } else {
        return this.TableData;
      }
    },
    timingClose() {
      return this.close;
    },

    DialogIsVisible() {
      let visible = this.isVisible;
      //console.log("DialogIsVisible hola", "\n visible: ", visible);
      return visible;
    },

    isValid: function () {
      return (
        this.changeDateForm.comment.trim().length > 5 &&
        this.changeDateForm.newdate !== null
      );
    },
    totalInvoices() {
      let totalAmount = 0;
      let amountArray = [];

      if (this.TableData.length > 0) {
        amountArray = this.TableData.map((payment) => payment.Amount);

        if (amountArray.length > 0) {
          totalAmount = amountArray.reduce((prev, next) => prev + next);
        }
      }
      return formatMonto(totalAmount);
    },
    // totalPaymentsRecorded() {
    //   let totalAmount = 0;
    //   let amountArray = [];

    //   if (this.TableData.length > 0) {
    //     // amountArray = this.TableData.map((payment) => console.log("computed",payment))
    //     amountArray = this.TableData.filter(
    //       (payment) => payment.Paid === true
    //     ).map((payment) => payment.Amount);

    //     console.log("amountarray", amountArray);

    //     if (amountArray.length > 0) {
    //       totalAmount = amountArray.reduce((prev, next) => prev + next);
    //     }
    //   }
    //   return formatMonto(totalAmount);
    // },

    totalInvoicesNotRecorded() {
      let totalAmount = 0;
      let amountArray = [];

      if (this.TableData.length > 0) {
        // amountArray = this.TableData.map((payment) => console.log("computed",payment))
        amountArray = this.TableData.filter(
          (payment) => payment.Paid === false
        ).map((payment) => payment.Amount);

        if (amountArray.length > 0) {
          totalAmount = amountArray.reduce((prev, next) => prev + next);
        }
      }
      return formatMonto(totalAmount);
    },

    totalOverdueInvoices() {
      let totalAmount = 0;
      let amountArray = [];

      let dateActually = new Date();
      let year = dateActually.getFullYear();
      let month = String(dateActually.getMonth() + 1).padStart(2, "0"); // Añade cero a la izquierda si es necesario
      let day = String(dateActually.getDate()).padStart(2, "0");
      let hours = String(dateActually.getHours()).padStart(2, "0");
      let minutes = String(dateActually.getMinutes()).padStart(2, "0");
      let seconds = String(dateActually.getSeconds()).padStart(2, "0");

      let formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

      if (this.TableData.length > 0) {
        // amountArray = this.TableData.map((payment) => console.log("computed",payment))
        amountArray = this.TableData.filter(
          (payment) => payment.Paid === false && payment.PayDay < formattedDate
        ).map((payment) => payment.Amount);

        if (amountArray.length > 0) {
          totalAmount = amountArray.reduce((prev, next) => prev + next);
        }
      }
      return formatMonto(totalAmount);
    },
    totalOverduePayment() {
      let totalAmount = 0;
      let amountArray = [];

      let dateActually = new Date();
      let year = dateActually.getFullYear();
      let month = String(dateActually.getMonth() + 1).padStart(2, "0"); // Añade cero a la izquierda si es necesario
      let day = String(dateActually.getDate()).padStart(2, "0");
      let hours = String(dateActually.getHours()).padStart(2, "0");
      let minutes = String(dateActually.getMinutes()).padStart(2, "0");
      let seconds = String(dateActually.getSeconds()).padStart(2, "0");

      let formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

      if (this.TableData.length > 0) {
        // amountArray = this.TableData.map((payment) => console.log("computed",payment))
        amountArray = this.TableData.filter(
          (payment) => payment.Paid === false && payment.PayDay < formattedDate
        ).map((payment) => payment.Amount);

        if (amountArray.length > 0) {
          totalAmount = amountArray.reduce((prev, next) => prev + next);
        }
      }
      return formatMonto(totalAmount);
    },
    totalPayments() {
      let totalAmount = 0;
      let amountArray = [];

      if (this.TableData.length > 0) {
        amountArray = this.TableData.map((payment) => payment.Amount);

        if (amountArray.length > 0) {
          totalAmount = amountArray.reduce((prev, next) => prev + next);
        }
      }
      return formatMonto(totalAmount);
    },
    totalPaymentsRecorded() {
      let totalAmount = 0;
      let amountArray = [];

      if (this.TableData.length > 0) {
        // amountArray = this.TableData.map((payment) => console.log("computed",payment))
        amountArray = this.TableData.filter(
          (payment) => payment.Paid === true
        ).map((payment) => payment.Amount);

        if (amountArray.length > 0) {
          totalAmount = amountArray.reduce((prev, next) => prev + next);
        }
      }
      return formatMonto(totalAmount);
    },

    totalPaymentsNotRecorded() {
      let totalAmount = 0;
      let amountArray = [];

      if (this.TableData.length > 0) {
        // amountArray = this.TableData.map((payment) => console.log("computed",payment))
        amountArray = this.TableData.filter(
          (payment) => payment.Paid === false
        ).map((payment) => payment.Amount);

        if (amountArray.length > 0) {
          totalAmount = amountArray.reduce((prev, next) => prev + next);
        }
      }
      return formatMonto(totalAmount);
    },
    billsWithoutPaymentDate() {
      return this.TableData.length;
    },
    TotalAmountWithoutPaymentDate() {
      let totalAmount = 0;
      let amountArray = [];

      if (this.TableData.length > 0) {
        amountArray = this.TableData.map((bill) => bill.Amount);

        if (amountArray.length > 0) {
          totalAmount = amountArray.reduce((prev, next) => prev + next);
        }
      }
      return formatMonto(totalAmount);
    },

    TotalExpiredAmount() {
      let totalAmount = 0;
      let amountArray = [];

      if (this.TableData.length > 0) {
        amountArray = this.TableData.filter(
          (bill) => bill.NumberOfDaysOverDue > 0
        ).map((bill) => bill.Amount);

        if (amountArray.length > 0) {
          totalAmount = amountArray.reduce((prev, next) => prev + next);
        }
      }
      return formatMonto(totalAmount);
    },
    TotalExpiredAmountCount() {
      let amountArray = [];

      if (this.TableData.length > 0) {
        amountArray = this.TableData.filter(
          (bill) => bill.NumberOfDaysOverDue > 0
        ).map((bill) => bill.Amount);
      }

      return Number.isNaN(amountArray.length) ? 0 : amountArray.length;
    },
    TotalUnexpiredAmountCount() {
      let amountArray = [];

      if (this.TableData.length > 0) {
        amountArray = this.TableData.filter(
          (bill) => bill.NumberOfDaysOverDue === 0
        ).map((bill) => bill.Amount);
      }
      return Number.isNaN(amountArray.length) ? 0 : amountArray.length;
    },
    TotalUnexpiredAmount() {
      let totalAmount = 0;
      let amountArray = [];

      if (this.TableData.length > 0) {
        amountArray = this.TableData.filter(
          (bill) => bill.NumberOfDaysOverDue === 0
        ).map((bill) => bill.Amount);

        if (amountArray.length > 0) {
          totalAmount = amountArray.reduce((prev, next) => prev + next);
        }
      }
      return formatMonto(totalAmount);
    },
    TotalClientsWithoutPortal() {
      let ClientsWithoutPortal = [];
      let CantClientsWithoutPortal = 0;
      ClientsWithoutPortal = this.TableData.filter(
        (client) => client.CantContactPortalWebInactive > 0
      );
      CantClientsWithoutPortal = ClientsWithoutPortal.length;
      //console.log("CantClientsWithoutPortal: ",CantClientsWithoutPortal)
      return CantClientsWithoutPortal;
    },
    TotalClientsWithoutApp() {
      let ClientsWithoutApp = [];
      let CantClientsWithoutApp = 0;
      ClientsWithoutApp = this.TableData.filter(
        (client) => client.CantContactsWithoutApp > 0
      );
      CantClientsWithoutApp = ClientsWithoutApp.length;
      //console.log("ClientsWithoutApp: ",ClientsWithoutApp)
      return CantClientsWithoutApp;
    },
    TotalClientsWithoutAppAndPortal() {
      let ClientsWithoutAppAndPortal = [];
      let CantClientsWithoutAppAndPortal = 0;

      ClientsWithoutAppAndPortal = this.TableData.filter(
        (client) =>
          client.CantContactsWithoutApp > 0 &&
          client.CantContactPortalWebInactive > 0
      );

      CantClientsWithoutAppAndPortal = ClientsWithoutAppAndPortal.length;
      return CantClientsWithoutAppAndPortal;
    }
  },
  methods: {
    ...mapActions({
      //getUserList: "navixy/getUserList",
      UpdateNavixyUser: "navixy/updateNavixyUser"
      //ObtainActualUserInfo: "navixy/ObtainActualUserInfo",
    }),
    async GetDetailsData() {
      this.dialogVisible = false;
      this.TableData = await ContractsPaymentgetTableData(this);
      if (this.TableData.length == 0) {
        this.isVisible = false;
      }
    },

    updateSelectedEmployee(val) {
      this.employeeId = val;
    },
    async handleChangeDirection(directionId) {
      this.loading = true;
      this.directionId = directionId;
      this.TableData = await getDelayedTasks(this, directionId);
      this.loading = false;
    },
    handleChangeSupervisor(supervisorId) {
      this.supervisorId = supervisorId;
    },

    CloseDetailDrawer() {
      this.dealDetailDrawer = false;
    },

    getContactsByCustomerCode(customerCode = String) {
      this.loadingContacts = true;
      this.$http
        .get("/api/contacts/GetContactByCustomerCode", {
          params: {
            customerCode: customerCode,
            companyCode: this.currentCompany
          }
        })
        .then(({ data }) => {
          this.contacts = data;
        })
        .catch((err) => {
          this.$message.error(
            `no se pudieron tener contacto sobre este cliente ${err}`
          );
        })
        .finally(() => {
          this.loadingContacts = false;
        });
    },

    getcomments(customerCode) {
      let parameters = {
        CustomerCode: customerCode,
        CompanyId: this.currentCompany
      };
      this.commentloading = true;
      this.$http
        .get("/api/interactions/InteractionsCustomerDetails", {
          params: parameters
        })
        .then((response) => {
          response.data.Items.forEach((row) => {
            if (row.Description) {
              const cleanComment = row.Description.replace(/(<([^>]+)>)/gi, "");
              row.Description = cleanComment;
            }
          });
          this.prospectDetailInteractions = response.data.Items;
          this.commentList = response.data.Items;
        })
        .finally(() => {
          this.commentloading = false;
        });
    },

    onSubmit() {
      var data = {
        OldDate: this.changeDateForm.currentdate,
        PromiseDate: this.changeDateForm.newdate,
        Motive: this.changeDateForm.comment,
        CustomerCode: this.AccountNumber,
        Amount: this.Amount,
        InvoiceNum: this.invoiceNum,
        ContactEmail: "",
        ContactNumber: this.changeDateForm.contactCode,
        CompanyID: this.currentCompany,
        SalesPersonCode: this.currentUser.PersonCode,
        CustomerServiceExec_: this.currentUser.CustomerServiceExec_
      };
      this.$http
        .post("/api/AccountsReceivable/ChangeDataFromDueDateToFutureDate", data)
        .then(({ data }) => {
          if (data) {
            this.formpayment = false;
            if (data.AddInteraction) {
              let msg =
                "Se ha creado una interacion con este compromiso de pago";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  title: "Creacion de Interacion",
                  position: "top-left"
                });
              }, 1500);
            }
            if (data.NotifyCustomer) {
              let msg = "El contacto ha sido notificado via correo";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  offset: 10,
                  title: "Notificacion a cliente",
                  position: "top-left"
                });
              }, 1500);
            }
            if (data.CashFlowModify) {
              let msg =
                "Se ha creado un movimiento en cashflow con este compromiso";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  offset: 20,
                  title: "Registro en cashflow",
                  position: "top-left"
                });
              }, 1500);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.handleClose();

          const PromiseIndex = this.items.findIndex(
            (promise) => promise.EntryNo == this.EntryNoIndex
          );
          this.items.splice(PromiseIndex, 1);
        });
    },
    handleClose() {
      this.changeDateForm.currentdate = "";
      this.changeDateForm.newdate = "";
      this.changeDateForm.comment = "";
      this.changeDateForm.contactName = "";
      this.changeDateForm.contactEmail = "";
      this.changeDateForm.contactNumber = "";
      this.changeDateForm.contactCode = "";
      this.changeDateForm.contactPhoneNumber = "";
      this.AccountNumber = "";
      this.contactCellphone = "";
      this.contactPhone = "";
      this.Amount = "";
      this.InvoiceNum = "";
      this.ContactEmail = "";
      this.formpayment = false;
      this.selectedRow = {};
    },

    handleIframeMessage(event) {
      if (event.origin === this.encuestaUrlBase) {
        // Handle the message received from the iframe
        if (event.data === "formSubmitted") {
          this.$emit("nextDialog");
        }
      }
      if (event.origin === this.encuestaUrlBase) {
        // Handle the message received from the iframe
        if (event.data === "isInactive") {
          this.$emit("nextDialog");
        }
      }
    },

    getContactNumber(contactCode) {
      var contact = this.contacts.find((c) => c.Code == contactCode);
      this.contactPhone = formatPhoneNumber(contact.PhoneNumber);
      this.contactCellphone = formatPhoneNumber(contact.MobilePhoneNumber);
    },

    async refreshTableSuccess() {
      this.loading = true;
      this.TableData = await QuealifyGetTableData(this);
      if (this.TableData.length == 0) {
        this.isVisible = false;
      }
      this.loading = false;
    },

    async refreshTableSuccessAutoMV() {
      this.loading = true;
      this.TableData = await GetAutoMVsPendingCalific(this);
      if (this.TableData.length == 0) {
        this.isVisible = false;
      }
      this.loading = false;
    },

    async refreshTableSuccessRequestsOnLate() {
      this.loading = true;
      this.TableData = await GetRequestOnLate(this);
      if (this.TableData.length == 0) {
        this.isVisible = false;
      }
      this.loading = false;
    },

    async handleTableUpdate() {
      this.TableData = await OportunityPaymentgetTableData(this);
      if (this.TableData.length == 0) {
        this.isVisible = false;
      }
      this.$emit("getUpdatedData");
    },

    async actionHandlerHelper(action) {
      this.currentActionSelected = action.command;
      /*
      console.log("actionHandlerHelper: ", action, "\n dialogo: ", dialog,
        "\n showDetail: ", showDetail, "\n detailData: ", detailData
      );
      */
      action.refs = this.$refs;

      const { CustomerNo, PostingDate, DocumentNo, EntryNo, client } =
        action.row;
      this.Amount = action.row.Amount;
      this.AccountNumber = CustomerNo;
      this.invoiceNum = DocumentNo;
      this.OldDate = PostingDate;
      this.CustomerData = client;

      const actionResult = await this.ActionHandler(action);
      if (action.command == "approve-task-percent") {
        this.$emit("updateLockerData", actionResult);
      }

      switch (action.command) {
        case "set": {
          //para buscar lista de empoleados para asignar
          const _params = {
            DirectionID: this.currentUser.DireccionID,
            Employeeid: this.currentUser.EmployeeId,
            DepartmentID: this.currentUser.DepartamentID,
            CompanySelected: this.currentCompany
          };
          //console.log("_params: ", _params);

          let uri = "";
          if (this.IsInRoles([this.roles.CEO])) {
            /*
           console.log(
              "is in rol: ",
              this.IsInRoles,
              "\n roles: ",
              this.roles
            );
            */
            uri = "/api/CMI/Objetives/GetUsersObjetivos";
          } else {
            /*
            console.log(
              "is not in rol: ",
              this.IsInRoles,
              "\n roles: ",
              this.roles
            );
            */
            uri = `/api/Employees/getEmployeeByhierarchy`;
          }

          let self = this;
          if (this.all) {
            uri =
              "/api/Employees/EmployeesByCompany?companyID=" +
              this.currentCompany;
            this.$http
              .get(uri, {})
              .then(({ data }) => {
                const a = formatArrayToElSelect(data, {
                  value: "EmployeeID"
                });
                this.employeList = a;
                self.$emit("list-employee", a);
              })
              .catch((err) => {
                if (err.message.includes("404")) {
                  const h = this.$createElement;
                  this.$message({
                    type: "info",
                    message: h("p", null, [
                      h("span", null, "Empleado no "),
                      h("i", { style: "color: teal" }, "encontrado")
                    ])
                  });
                } else {
                  this.$alert(err.message, err.name, {
                    type: "error"
                  });
                }
              })
              .finally(() => (this.loading = false));
          } else {
            this.getEmployeeByParams(uri, _params, self);
          }
          break;
        }

        case "reopen": {
          this.dialog.internalRequestId = action.row.Id;
          this.dialog.title =
            "Agrega tu comentario del porque se debe 'Reabrir la solicitud'";
          this.dialog.type = "addcommentReasonToReopen";
          this.dialog.visible = true;
          break;
        }

        case "contract-renovation-command": {
          const Parameters = {
            params: {
              CompanyCode: this.currentCompany,
              SellerCode: this.currentUser.PersonCode,
              CustomerServicesCode: this.currentUser.CustomerServiceExec_, //!= null ? this.currentUser.CustomerServiceExec_ : 0,
              EmployeeId: this.currentUser.EmployeeId,
              UserId: this.currentUser.UserID,
              year: new Date().getFullYear(),
              month: new Date().getMonth() + 1,
              optionStr: "cv"
            }
          };

          await this.$http
            .get("/api/MessageApi/GetExcutiveStatDetails", Parameters)
            .then((response) => {
              this.actions = response.data[0].Contracts;
              this.currentActionData = this.actions[action.index];
              this.ContractsRenovationKey++;
              this.dialogVisible = true;
            });

          break;
        }

        case "view-contract-Lines-command": {
          //console.log("details props: ", action);
          this.$refs.details.show(action);
          break;
        }

        case "contract-cancelation-command": {
          this.currentActionData = action;

          //this.InactivateNavixyUser(action.row.ClientCode);
          this.ConfimrContractCancelView = true;
          /*
          do{'nada, solo espera'}
          while (this.isCancelationConfirmed === false)
          */
          /*
          if (this.isCancelationConfirmed === true) {


          }
          else {

          }
          */
          // this.$confirm(
          //   "Estas apunto de cerrar este contrato en navision y de generar un ticket de desinstalacion para todas sus lineas de contrato, asi como para desactivar el usuario del cliente en navixy." +
          //     "\n\n <strong>Seguro que desea continuar?</strong>",
          //   "Cuidado !",
          //   {
          //     dangerouslyUseHTMLString: true,
          //     confirmButtonText: "OK",
          //     cancelButtonText: "Cancel",
          //     type: "warning"
          //   }
          // )
          //   .then(async () => {
          //     this.$message({
          //       type: "info",
          //       message: `Procedemos con el con la solicitud de desinstalacion del contrato: #${action.row.NoContrato}`
          //     });

          //     await this.fecthCustomers();
          //     await this.CustomersList;
          //     CurrentClient = this.CustomersList.filter(
          //       (Cust) => Cust.ClientCode === action.row.ClientCode
          //     )[0];
          //     /*
          //     console.log(
          //       "CustomersList: ",
          //       this.CustomersList,
          //       "\nAction row: ",
          //       action.row,
          //       "\nCurrent client: ",
          //       CurrentClient
          //     );
          //     */

          //     await this.$refs.dialogNewRequestForContractCancelation.show(
          //       action.row.ClientCode,
          //       CurrentClient
          //     );
          //   })
          //   .catch(() => {
          //     this.$message({
          //       type: "info",
          //       message: `Cierre del contrato: #${action.row.NoContrato} Cancelado`
          //     });
          //   });

          break;
        }

        case "view-request-onLate": {
          this.$refs.form.draw(action.row.Id);
          break;
        }

        case "AddComment-onLate": {
          this.RequestIdDialog = action.row.Id;
          this.DialogCommentOnLateOpen = true;
          break;
        }

        case "view-auto-mv": {
          // let today = new Date();
          // let validateToday = today.getDay();
          // // Obtener la fecha de inicio y fin de la semana actual
          // const fechaActual = new Date();
          // const primerDiaSemanaActual = new Date(
          //   fechaActual.setDate(fechaActual.getDate() - fechaActual.getDay())
          // );
          // const ultimoDiaSemanaActual = new Date(
          //   fechaActual.setDate(primerDiaSemanaActual.getDate() + 6)
          // );

          // const ultimoDiaSemanaPasada = new Date(
          //   fechaActual.setDate(primerDiaSemanaActual.getDate() - 1)
          // );

          // const primerDiaSemanaPasada = new Date(
          //   fechaActual.setDate(ultimoDiaSemanaPasada.getDate() - 6)
          // );

          this.$http
            .get(`/api/CMI/AutoMVs/GetAutoMVsById?id=${action.row.IdAutoMV}`)
            .then((resp) => {
              this.DataAutoMVFormModel = resp.data;
              const createdAt = new Date(resp.data.CreatedAt);
              this.createdAtt = resp.data.CreatedAt;

              //LOGICA PARA TAB OPERACIONAL
              this.TasktableDataOperacional = resp.data.task.filter((data) => {
                return data.TypeStrategic === 1 && data.StausTasks != 3;
              });

              //Total de datareas cerrada a tiempo
              this.totalTaksClosedOnTimeOperacional = resp.data.task.filter(
                (data) => data.StausTasks == 1 && data.TypeStrategic === 1
              );

              //Total de datareas cerrada a tiempo en la semana
              this.taksClosedOnTimeOperacional = resp.data.task.filter(
                (data) => {
                  const fechaCierre = new Date(data.ClosedDate);

                  var diferenciaMilisegundos = Math.abs(
                    createdAt.getTime() - fechaCierre.getTime()
                  );

                  // Calcular la diferencia en días
                  var diferenciaDias = Math.floor(
                    diferenciaMilisegundos / (1000 * 60 * 60 * 24)
                  );

                  return (
                    diferenciaDias <= 7 &&
                    data.StausTasks == 1 &&
                    data.TypeStrategic === 1
                  );
                }
              );

              //Total de tareas cerrada retrasadas
              this.totalTaksClosedOnLateOperacional = resp.data.task.filter(
                (data) => data.StausTasks == 2 && data.TypeStrategic === 1
              );

              //Total de tareas cerrada retrasadas de la semana
              this.taskCloseOnLateOnWeekOperacional = resp.data.task.filter(
                (evento) => {
                  // const fechaLimite = new Date(evento.LimiteDate);
                  const fechaCierre = new Date(evento.ClosedDate);

                  var diferenciaMilisegundos = Math.abs(
                    createdAt.getTime() - fechaCierre.getTime()
                  );

                  // Calcular la diferencia en días
                  var diferenciaDias = Math.floor(
                    diferenciaMilisegundos / (1000 * 60 * 60 * 24)
                  );

                  return (
                    diferenciaDias <= 7 &&
                    evento.StausTasks == 2 &&
                    evento.TypeStrategic === 1
                  );
                }
              );

              this.totalTaksOpenOnTimeOperacional = resp.data.task.filter(
                (data) => data.StausTasks == 3 && data.TypeStrategic === 1
              );

              this.taksOpenOnTimeOperacional = resp.data.task.filter(
                (evento) => {
                  const fechaLimite = new Date(evento.LimiteDate);

                  var diferenciaMilisegundos = Math.abs(
                    createdAt.getTime() - fechaLimite.getTime()
                  );

                  // Calcular la diferencia en días
                  var diferenciaDias = Math.floor(
                    diferenciaMilisegundos / (1000 * 60 * 60 * 24)
                  );

                  return (
                    diferenciaDias <= 7 &&
                    fechaLimite >= createdAt &&
                    evento.StausTasks == 3 &&
                    evento.TypeStrategic === 1
                  );
                }
              );

              this.totalTaksOpenOnLateOperacional = resp.data.task.filter(
                (data) => data.StausTasks == 4 && data.TypeStrategic === 1
              );

              this.taskOpenOnLateOnWeekOperacional = resp.data.task.filter(
                (evento) => {
                  const fechaLimite = new Date(evento.LimiteDate);

                  var diferenciaMilisegundos = Math.abs(
                    createdAt.getTime() - fechaLimite.getTime()
                  );

                  // Calcular la diferencia en días
                  var diferenciaDias = Math.floor(
                    diferenciaMilisegundos / (1000 * 60 * 60 * 24)
                  );

                  return (
                    diferenciaDias <= 7 &&
                    fechaLimite <= createdAt &&
                    evento.StausTasks == 4 &&
                    evento.TypeStrategic === 1
                  );
                }
              );

              //LOGICA PARA OPERACIONAL
              this.percetangeWeekOperacional =
                (this.taksClosedOnTimeOperacional.length /
                  (this.taksClosedOnTimeOperacional.length +
                    this.taskOpenOnLateOnWeekOperacional.length +
                    this.taskCloseOnLateOnWeekOperacional.length)) *
                100;

              this.percetangeWeekOperacional = Math.round(
                this.percetangeWeekOperacional
              );

              this.percetangeTotalOperacional =
                (this.totalTaksClosedOnTimeOperacional
                  .length /*+ this.totalTaksClosedOnLate*/ /*this.totalTaksOpenOnTime +*/ /
                  (this.totalTaksOpenOnLateOperacional.length +
                    this.totalTaksClosedOnTimeOperacional.length +
                    this.totalTaksClosedOnLateOperacional.length)) *
                100;
              this.percetangeTotalOperacional = Math.round(
                this.percetangeTotalOperacional
              );

              this.TasktableDataEstrategico = resp.data.task.filter((data) => {
                return data.TypeStrategic === 2 && data.StausTasks != 3;
              });

              // Total de tareas completadas estrategico
              this.totalTaksClosedOnTimeEstrategico = resp.data.task.filter(
                (data) => data.StausTasks == 1 && data.TypeStrategic === 2
              );

              this.taksClosedOnTimeEstrategico = resp.data.task.filter(
                (evento) => {
                  const fechaCierre = new Date(evento.ClosedDate);

                  var diferenciaMilisegundos = Math.abs(
                    createdAt.getTime() - fechaCierre.getTime()
                  );

                  // Calcular la diferencia en días
                  var diferenciaDias = Math.floor(
                    diferenciaMilisegundos / (1000 * 60 * 60 * 24)
                  );

                  return (
                    diferenciaDias <= 7 &&
                    evento.StausTasks == 1 &&
                    evento.TypeStrategic === 2
                  );
                }
              );

              // this.totalTaksClosedOnTimeEstrategico.push(d);
              this.totalTaksClosedOnLateEstrategico = resp.data.task.filter(
                (data) => data.StausTasks == 2 && data.TypeStrategic === 2
              );

              this.taskCloseOnLateOnWeekEstrategico = resp.data.task.filter(
                (evento) => {
                  const fechaCierre = new Date(evento.ClosedDate);

                  var diferenciaMilisegundos = Math.abs(
                    createdAt.getTime() - fechaCierre.getTime()
                  );

                  // Calcular la diferencia en días
                  var diferenciaDias = Math.floor(
                    diferenciaMilisegundos / (1000 * 60 * 60 * 24)
                  );

                  return (
                    diferenciaDias <= 7 &&
                    evento.StausTasks == 2 &&
                    evento.TypeStrategic === 2
                  );
                }
              );

              this.totalTaksOpenOnTimeEstrategico = resp.data.task.filter(
                (data) => data.StausTasks == 3 && data.TypeStrategic === 2
              );

              this.taksOpenOnTimeEstrategico = resp.data.task.filter(
                (evento) => {
                  const fechaLimite = new Date(evento.LimiteDate);

                  var diferenciaMilisegundos = Math.abs(
                    createdAt.getTime() - fechaLimite.getTime()
                  );

                  // Calcular la diferencia en días
                  var diferenciaDias = Math.floor(
                    diferenciaMilisegundos / (1000 * 60 * 60 * 24)
                  );

                  return (
                    diferenciaDias <= 7 &&
                    fechaLimite >= createdAt &&
                    evento.StausTasks == 3 &&
                    evento.TypeStrategic === 2
                  );
                }
              );
              this.totalTaksOpenOnLateEstrategico = resp.data.task.filter(
                (data) => data.StausTasks == 4 && data.TypeStrategic === 2
              );

              this.taskOpenOnLateOnWeekEstrategico = resp.data.task.filter(
                (evento) => {
                  const fechaLimite = new Date(evento.LimiteDate);

                  var diferenciaMilisegundos = Math.abs(
                    createdAt.getTime() - fechaLimite.getTime()
                  );

                  // Calcular la diferencia en días
                  var diferenciaDias = Math.floor(
                    diferenciaMilisegundos / (1000 * 60 * 60 * 24)
                  );

                  return (
                    diferenciaDias <= 7 &&
                    fechaLimite <= createdAt &&
                    evento.StausTasks == 4 &&
                    evento.TypeStrategic === 2
                  );
                }
              );

              //LOGICA PAR ESTRATEGICO
              this.percetangeWeekEstrategico =
                (this.totalTaksClosedOnTimeEstrategico.length /
                  (this.totalTaksClosedOnTimeEstrategico.length +
                    this.taskOpenOnLateOnWeekEstrategico.length +
                    this.taskCloseOnLateOnWeekEstrategico.length)) *
                100;
              this.percetangeWeekEstrategico = Math.round(
                this.percetangeWeekEstrategico
              );

              this.percetangeTotalEstrategico =
                (this.totalTaksClosedOnTimeEstrategico
                  .length /*+ this.totalTaksClosedOnLate*/ /*this.totalTaksOpenOnTime +*/ /
                  (this.totalTaksOpenOnLateEstrategico.length +
                    this.totalTaksClosedOnTimeEstrategico.length +
                    this.totalTaksClosedOnLateEstrategico.length)) *
                100;

              this.percetangeTotalEstrategico = Math.round(
                this.percetangeTotalEstrategico
              );

              this.loading = false;
            })
            .catch((err) => {
              console.error("Error en GetAutoMVsByOwner: ", err);
            });
          this.openAutoMVView = true;

          break;
        }

        case "edit-eventFinaces": {
          this.dataInvoices2 = action.row;
          //this.dialogTitleEvent;
          this.openEditEvent = true;
          break;
        }

        case "edit-auto-mv": {
          let today = new Date();
          let validateToday = today.getDay();
          // Obtener la fecha de inicio y fin de la semana actual
          const fechaActual = new Date();
          const primerDiaSemanaActual = new Date(
            fechaActual.setDate(fechaActual.getDate() - fechaActual.getDay())
          );
          const ultimoDiaSemanaActual = new Date(
            fechaActual.setDate(primerDiaSemanaActual.getDate() + 6)
          );

          const ultimoDiaSemanaPasada = new Date(
            fechaActual.setDate(primerDiaSemanaActual.getDate() - 1)
          );

          const primerDiaSemanaPasada = new Date(
            fechaActual.setDate(ultimoDiaSemanaPasada.getDate() - 6)
          );
          this.$http
            .get(`/api/CMI/AutoMVs/GetAutoMVsById?id=${action.row.IdAutoMV}`)
            .then((resp) => {
              this.DataAutoMVFormModel = resp.data;

              resp.data.task.forEach((d) => {
                this.TasktableDataOperacional = resp.data.task.filter(
                  (data) => {
                    return data.TypeStrategic === 1;
                  }
                );

                if (d.StausTasks == 1 && d.TypeStrategic === 1) {
                  this.totalTaksClosedOnTimeOperacional.push(d);
                } else if (d.StausTasks == 2 && d.TypeStrategic === 1) {
                  this.totalTaksClosedOnLateOperacional.push(d);

                  this.taskCloseOnLateOnWeekOperacional = resp.data.task.filter(
                    (evento) => {
                      const fechaCierre = new Date(evento.LimiteDate);

                      if (
                        validateToday == 5 /*viernes*/ ||
                        validateToday == 6 /*Sabado*/
                      ) {
                        return (
                          fechaCierre >= primerDiaSemanaActual &&
                          fechaCierre <= ultimoDiaSemanaActual &&
                          evento.StausTasks == 2
                        );
                      }
                      return (
                        fechaCierre >= primerDiaSemanaPasada &&
                        fechaCierre <= ultimoDiaSemanaPasada &&
                        evento.StausTasks == 2
                      );
                    }
                  );
                } else if (d.StausTasks == 3 && d.TypeStrategic === 1) {
                  this.totalTaksOpenOnTimeOperacional.push(d);
                } else if (d.StausTasks == 4 && d.TypeStrategic === 1) {
                  this.totalTaksOpenOnLateOperacional.push(d);

                  this.taskOpenOnLateOnWeekOperacional = resp.data.task.filter(
                    (evento) => {
                      // console.log("aaaa",primerDiaSemana, ultimoDiaSemana)
                      // console.log("pasada",primerDiaSemanaPasada, ultimoDiaSemanaPasada)
                      const fechaCierre = new Date(evento.LimiteDate);

                      if (
                        validateToday == 5 /*viernes*/ ||
                        validateToday == 6 /*Sabado*/
                      ) {
                        return (
                          fechaCierre >= primerDiaSemanaActual &&
                          fechaCierre <= ultimoDiaSemanaActual &&
                          evento.StausTasks == 4
                        );
                      }
                      return (
                        fechaCierre >= primerDiaSemanaPasada &&
                        fechaCierre <= ultimoDiaSemanaPasada &&
                        evento.StausTasks == 4
                      );
                    }
                  );
                }

                this.percetangeWeekOperacional =
                  (this.totalTaksClosedOnTimeOperacional.length /
                    (this.totalTaksClosedOnTimeOperacional.length +
                      this.taskOpenOnLateOnWeekOperacional.length +
                      this.taskCloseOnLateOnWeekOperacional.length)) *
                  100;
                this.percetangeWeekOperacional = Math.round(
                  this.percetangeWeekOperacional
                );

                this.percetangeTotalOperacional =
                  (this.totalTaksClosedOnTimeOperacional
                    .length /*+ this.totalTaksClosedOnLate*/ /*this.totalTaksOpenOnTime +*/ /
                    (this.totalTaksOpenOnLateOperacional.length +
                      this.totalTaksClosedOnTimeOperacional.length +
                      this.totalTaksClosedOnLateOperacional.length)) *
                  100;
                this.percetangeTotalOperacional = Math.round(
                  this.percetangeTotalOperacional
                );

                //LOGICA PARA ESTRATEGICO

                this.TasktableDataEstrategico = resp.data.task.filter(
                  (data) => {
                    return data.TypeStrategic === 2;
                  }
                );

                if (d.StausTasks == 1 && d.TypeStrategic === 2) {
                  this.totalTaksClosedOnTimeEstrategico.push(d);
                } else if (d.StausTasks == 2 && d.TypeStrategic === 2) {
                  this.totalTaksClosedOnLateEstrategico.push(d);

                  this.taskCloseOnLateOnWeekEstrategico = resp.data.task.filter(
                    (evento) => {
                      // console.log("aaaa", evento);
                      // console.log("pasada",primerDiaSemanaPasada, ultimoDiaSemanaPasada)
                      const fechaCierre = new Date(evento.LimiteDate);

                      if (
                        validateToday == 5 /*viernes*/ ||
                        validateToday == 6 /*Sabado*/
                      ) {
                        return (
                          fechaCierre >= primerDiaSemanaActual &&
                          fechaCierre <= ultimoDiaSemanaActual &&
                          evento.StausTasks == 2
                        );
                      }
                      return (
                        fechaCierre >= primerDiaSemanaPasada &&
                        fechaCierre <= ultimoDiaSemanaPasada &&
                        evento.StausTasks == 2
                      );
                    }
                  );
                } else if (d.StausTasks == 3 && d.TypeStrategic === 2) {
                  this.totalTaksOpenOnTimeEstrategico.push(d);
                } else if (d.StausTasks == 4 && d.TypeStrategic === 2) {
                  this.totalTaksOpenOnLateEstrategico.push(d);

                  this.taskOpenOnLateOnWeekEstrategico = resp.data.task.filter(
                    (evento) => {
                      // console.log("aaaa",primerDiaSemana, ultimoDiaSemana)
                      // console.log("pasada",primerDiaSemanaPasada, ultimoDiaSemanaPasada)
                      const fechaCierre = new Date(evento.LimiteDate);

                      if (
                        validateToday == 5 /*viernes*/ ||
                        validateToday == 6 /*Sabado*/
                      ) {
                        return (
                          fechaCierre >= primerDiaSemanaActual &&
                          fechaCierre <= ultimoDiaSemanaActual &&
                          evento.StausTasks == 4
                        );
                      }
                      return (
                        fechaCierre >= primerDiaSemanaPasada &&
                        fechaCierre <= ultimoDiaSemanaPasada &&
                        evento.StausTasks == 4
                      );
                    }
                  );
                }
                this.percetangeWeekEstrategico =
                  (this.totalTaksClosedOnTimeEstrategico.length /
                    (this.totalTaksClosedOnTimeEstrategico.length +
                      this.taskOpenOnLateOnWeekEstrategico.length +
                      this.taskCloseOnLateOnWeekEstrategico.length)) *
                  100;
                this.percetangeWeekEstrategico = Math.round(
                  this.percetangeWeekEstrategico
                );

                this.percetangeTotalEstrategico =
                  (this.totalTaksClosedOnTimeEstrategico
                    .length /*+ this.totalTaksClosedOnLate*/ /*this.totalTaksOpenOnTime +*/ /
                    (this.totalTaksOpenOnLateEstrategico.length +
                      this.totalTaksClosedOnTimeEstrategico.length +
                      this.totalTaksClosedOnLateEstrategico.length)) *
                  100;
                this.percetangeTotalEstrategico = Math.round(
                  this.percetangeTotalEstrategico
                );
              });
              // resp.data.task.forEach((d) => {
              //   this.TasktableData.push(d);
              //   if (d.StausTasks == 1) {
              //     this.totalTaksClosedOnTime.push(d);
              //   } else if (d.StausTasks == 2) {
              //     this.totalTaksClosedOnLate.push(d);
              //   } else if (d.StausTasks == 3) {
              //     this.totalTaksOpenOnTime.push(d);
              //   } else if (d.StausTasks == 4) {
              //     this.totalTaksOpenOnLate.push(d);
              //   }
              // });
              this.loading = false;
            })
            .catch((err) => {
              console.error("Error en GetAutoMVsByOwner: ", err);
            });

          this.openAutoMVView = true;
          this.isSupervisor = true;

          break;
        }

        case "edit-oportunity": {
          this.items = await OportunityPaymentgetTableData(this);
          this.index = this.items[action.index];

          var { data } = await this.$http.get("/api/deals/GetByID/", {
            timeout: 3 * 60 * 1000,
            params: {
              DealsId: this.index.DealsId
            }
          });
          this.dealDetailTitle = `Detalle de Oportunidad # ${this.index.DealsId}`;

          const isClient = data.CustomerCode
            ? data.CustomerCode.startsWith("CL")
            : false;
          const isProspect = data.CustomerCode
            ? data.CustomerCode.startsWith("C0")
            : false;
          const code = data.CustomerCode ?? "";

          this.dealDetailBind.isClient = isClient;
          this.dealDetailBind.isProspect = isProspect;
          this.dealDetailBind.code = code;
          this.dealDetailBind.Name = data.Name;
          this.dealDetailBind.initModel = { ...data };
          //console.log(data);
          this.dealDetailBind.isView = false;
          this.dealDetailBind.isEdit = true;
          this.dealDetailDrawer = true;

          break;
        }

        case "change-date-payment": {
          this.formpayment = true;
          this.changeDateForm.currentdate = PostingDate;
          this.getContactsByCustomerCode(CustomerNo);
          this.EntryNoIndex = EntryNo;
          break;
        }

        case "see-comments": {
          this.comments = true;
          this.getcomments(CustomerNo);
          break;
        }

        case "rate-validation-request-command": {
          this.$refs.record_rating.show(action.row);
          //this.isVisible = false;
          break;
        }

        case "details_view": {
          this.$refs.form.draw(action.row.Id);
          break;
        }

        case "new_interaction": {
          this.CustomerData = action.row;
          this.$refs.dialogNewInteraction.show(action.row.ClientCode);
          break;
        }

        case "addComment": {
          break;
        }

        case "cancell": {
          break;
        }

        case "work": {
          break;
        }

        case "close": {
          break;
        }

        case "details": {
          if (this.DialogTitle.includes("calificar")) {
            let ShowDetailRateT = showDetailRate;
            let detailDataRateT = detailDataRate;
            this.showDetailRate = ShowDetailRateT;
            this.detailDataRate = detailDataRateT;

            // this.InternalRequestDrawerKeyRate++;
          } else {
            let showDetailT = showDetail;
            this.showDetail = showDetailT;
            let detailDataT = detailData;
            this.detailData = detailDataT;

            this.InternalRequestDrawerKey++;
          }
          // const elements = document.getElementsByClassName("v-modal");
          // let i = 0;
          // while (elements.length > i) {
          //   elements[i].remove();
          //   i++;
          // }
          break;
        }
        case "change-cashflow-date-payment":
          //console.log("holaaa: action", action);
          this.$refs.changePostingDate.show(action.row);
          break;
        case "execute": {
          //console.log("holaaa action: ", action);
          this.toExecute(action.row.Id);

          break;
        }
        case "activate-internal-request": {
          //console.log("holaaa action: ", action);
          this.PaymentResquest.DirectionId = 28;
          this.PaymentResquest.ResquestTypeId = 224;
          this.$refs.NewFormRequest.drawer = true;

          break;
        }
        case "create_support_request": {
          this.$refs.dialogNewRequest.show(
            action.row.client.ClientCode,
            action.row.client
          );

          break;
        }
        case "create_client_iteration": {
          if (
            this.$store.state.interactions.list_interaction_code.length <= 0
          ) {
            this.$store.dispatch("interactions/get_interaction_code");
          }
          this.$refs.dialogNewInteraction.show(action.row.client.ClientCode);
          break;
        }
        case "create_client_iteration_from_PortalAPP": {
          if (
            this.$store.state.interactions.list_interaction_code.length <= 0
          ) {
            this.$store.dispatch("interactions/get_interaction_code");
          }
          this.CustomerData = action.row;
          //console.log("row in action: ",action.row)
          this.$refs.dialogNewInteraction.show(action.row.CustomerCode);
          break;
        }

        case "delete-task":
          //console.log("cono: ", action)
          this.$confirm(
            "Borraras la tarea seleccionada. Deseas continuar?",
            "Warning",
            {
              confirmButtonText: "Si",
              cancelButtonText: "Cancelar",
              type: "warning"
            }
          )
            .then(async () => {
              await this.$http.delete(
                `api/CMI/Task/DeleteGanttTask?TaskID=${action.row.CombinedId}`
              );
              this.$message({
                type: "success",
                message: "Tarea Borrada con Exito"
              });
              this.TableData = await getDelayedTasks(this, this.directionId);
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Operacion Cancelada"
              });
            });
          break;

        case "client_report_exclude":
          // console.log("this action: ", action)

          this.$confirm(
            "Esta seguro que quiere excluir el cliente?, de ser asi incluir un motivo de exclusion",
            "Warning",
            {
              confirmButtonText: "Excluir",
              cancelButtonText: "Cancelar",
              showInput: true,
              inputPlaceholder: "Motivo para excluir al cliente",
              type: "warning"
            }
          )
            .then((exclmsj) => {
              // console.log("this action en el confirm: ", action)
              const params = {
                CustomerCode: action.row.CustomerCode,
                CustomerName: action.row.CustomerName,
                CustomerEmail: action.row.CustomerEmail,
                CustomerPhone: action.row.CustomerPhone,
                ExclusionReason: exclmsj.value
              };
              // console.log("params: ", params)
              this.$http
                .post("/api/customers/ExcludeClientFromPortalApp", params)
                .then(() => {
                  this.$message({
                    type: "success",
                    message: "Exclusion completada"
                  });
                  this.onTableData = this.onTableData.splice(action.index, 1);
                })
                .catch((err) => {
                  console.error(err);
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Exclusion cancelada"
              });
            });
          break;

        default:
          document.getElementsByClassName("v-modal")[0].remove();
          break;
      }
    },
    getEmployeeByParams(uri, _params, self) {
      /*
      console.log(
        "getEmployeeByParams",
        "\nuri: ",
        uri,
        "\n_params: ",
        _params,
        "\nself: ",
        self
      );
      */
      this.$http
        .get(uri, { params: { ..._params } })
        .then(({ data }) => {
          //console.log("getEmployeeByParams: ", data);
          const a = formatArrayToElSelect(data, {
            value: "EmployeeID"
          });
          //console.log("a: ", a);
          this.employeList = a;
          self.$emit("list-employee", a);
        })
        .catch((err) => {
          if (err.message.includes("404")) {
            const h = this.$createElement;
            this.$message({
              type: "info",
              message: h("p", null, [
                h("span", null, "Empleado no "),
                h("i", { style: "color: teal" }, "encontrado")
              ])
            });
          } else {
            this.$alert(err.message, err.name, {
              type: "error"
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    handleCloseDialog(done) {
      done();
    },
    closeEditEventFinances() {
      this.openEditEvent = false;
    },
    closeAutoMVView() {
      this.openAutoMVView = false;
      this.isSupervisor = false;
      // this.TasktableData = [];
      // this.totalTaksClosedOnTime = [];
      // this.totalTaksClosedOnLate = [];
      // this.totalTaksOpenOnTime = [];
      // this.totalTaksOpenOnLate = [];
      // this.taskCloseOnLateOnWeek = [];
      // this.taskOpenOnLateOnWeek = [];
      this.TasktableDataOperacional = [];
      this.totalTaksClosedOnTimeOperacional = [];
      this.totalTaksClosedOnLateOperacional = [];
      this.totalTaksOpenOnTimeOperacional = [];
      this.totalTaksOpenOnLateOperacional = [];
      this.taskCloseOnLateOnWeekOperacional = [];
      this.taskOpenOnLateOnWeekOperacional = [];
      this.TasktableDataEstrategico = [];
      this.totalTaksClosedOnTimeEstrategico = [];
      this.totalTaksClosedOnLateEstrategico = [];
      this.totalTaksOpenOnTimeEstrategico = [];
      this.totalTaksOpenOnLateEstrategico = [];
      this.taskCloseOnLateOnWeekEstrategico = [];
      this.taskOpenOnLateOnWeekEstrategico = [];
      this.percetangeWeekOperacional = 0;
      this.percetangeTotalOperacional = 0;
      this.percetangeWeekEstrategico = 0;
      this.percetangeTotalEstrategico = 0;
    },
    cancelDialog() {
      this.dialog.visible = false;
      this.$refs.form.resetFields();
    },

    confirmDialog() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.dialog.type === "set") {
            let self = this;
            this.$http
              .get("/api/InternalServiceRequest/SetResponsable", {
                params: {
                  internalRequestId: this.dialog.internalRequestId,
                  responsableId: this.dialog.responsableId,
                  supervisorId: this.currentUser.EmployeeId
                },
                timeout: 3 * 60 * 100
              })
              .then((resp) => {
                if (resp.data) {
                  this.$message({
                    type: "success",
                    message: "Responsable establecido exitosamente!"
                  });
                } else {
                  this.$message.error("Error al establecer responsable");
                }
              })
              .catch((error) => {
                this.$message.error("Error al establecer responsable", error);
              })
              .finally(async function () {
                //console.log("currentUser: ", self.currentUser);
                self.cancelDialog();
                self.TableData = await GetInternalRequestWithoutAssigment(
                  self.currentUser
                );
              });
          } else if (this.dialog.type === "addComment") {
            let self = this;
            this.$http
              .get("/api/InternalServiceRequest/addComments", {
                params: {
                  comments: this.dialog.comment,
                  internalRequestId: this.dialog.internalRequestId,
                  createBy: this.currentUser.EmployeeId,
                  tipo: 1
                },
                timeout: 3 * 60 * 100
              })
              .then((resp) => {
                //console.log("commente2: ", resp.data)
                if (resp.data) {
                  this.$message({
                    type: "success",
                    message: "comentario agregado exitosamente!"
                  });
                } else {
                  this.$message.error("Error al agregar comentario");
                }
              })
              .catch((error) => {
                //console.log("commente2 catch: ", error)
                this.$message.error("Error al agregar comentario", error);
              })
              .finally(async function () {
                //console.log("currentUsercomment: ", self.currentUser);
                self.cancelDialog();
                self.TableData = await GetInternalRequestWithoutAssigment(
                  self.currentUser
                );
              });
          } else if (this.dialog.type === "addcommentReasonToReopen") {
            let self = this;
            this.$http
              .get("/api/InternalServiceRequest/reOpen", {
                params: {
                  internalRequestId: this.dialog.internalRequestId,
                  commentReasonToReopen: this.dialog.commentReasonToReopen
                },
                timeout: 3 * 60 * 100
              })
              .then((resp) => {
                // console.log("commente2: ", resp);
                if (resp.status == 200) {
                  this.$message({
                    type: "success",
                    message: "Solicitud reabierta exitosamente!"
                  });
                } else {
                  this.$message.error("Error al reabrir solicitud");
                }
              })
              .catch((error) => {
                //console.log("commente2 catch: ", error)
                this.$message.error("Error al reabrir solicitud", error);
              })
              .finally(async function () {
                //console.log("currentUsercomment: ", self.currentUser);
                self.cancelDialog();
                self.TableData = await GetInternalRequestWithoutAssigment(
                  self.currentUser
                );
              });
          }
        } else {
          return false;
        }
      });
    },
    OnCoclose() {
      this.$emit("onClose");
      this.isDevEnv = false;
      this.saveButtonVisible = false;
      /*
      if (this.TableData.length === 0 ){
      }
      */
    }, //OLA
    validaUserClose() {
      // console.log("data", this.currentUser, this.currentUser.Roles[0].Id);
      var valid = false;
      var valid2 = false;
      var valid3 = false;
      var valid4 = false;
      //var valid3 = false;
      this.TableData.forEach((data) => {
        if (this.DialogTitle == "Oportunidades vencidas") {
          // console.log("data 2",data );
          if (
            data.SupportSellerId == this.currentUser.EmployeeId ||
            this.currentUser.PositionID == 25 ||
            this.currentUser.PositionID == 53
          ) {
            this.closeDialogSeller = false;
            valid = true;
          } else if (data.SellerId == this.currentUser.PersonCode) {
            this.closeDialogSeller = false;
            valid = true;
          } /*else if(this.currentUser.PositionID == 53){
            this.closeDialogSeller = false;
            valid = true;
          }*/
        }
        if (this.DialogTitle == "Tareas por aprobar") {
          if (data.SupervisorID == this.currentUser.EmployeeId) {
            this.closeDialogSeller = false;
            valid3 = true;
          }
        }
      });

      if (valid) {
        const h = this.$createElement;
        this.$notify({
          message: h("b", null, [
            h(
              "span",
              null,
              "Debes de cambiar las fechas de cierres vencidas de la Oportunidades que le corresponde a usted o hablar con soporte de venta, para poder cerrar esta"
            ),
            h("i", { style: "color: teal" }, " Ventana")
          ]),
          duration: 0,
          type: "warning"
        });
      } else if (this.DialogTitle == "Solicitudes por calificar") {
        this.TableData.forEach((data) => {
          this.currentUser.Roles.forEach((dataROL) => {
            if (
              dataROL.Id == 25 &&
              data.CustomerServiceCode == this.currentUser.CustomerServiceExec_
            ) {
              this.closeDialogSeller = false;
              valid2 = true;
              return true;
            }
          });
        });
      }

      if (valid2) {
        const h = this.$createElement;
        this.$notify({
          message: h("b", null, [
            h(
              "span",
              null,
              "Debes de calificar las solicitudes pendientes para poder cerrar La "
            ),
            h("i", { style: "color: teal" }, "ventana")
          ]),
          duration: 0,
          type: "warning"
        });
      }

      if (valid3) {
        const h = this.$createElement;
        this.$notify({
          message: h("b", null, [
            h(
              "span",
              null,
              "Debes aprobar las tareas para poder cerrar esta ventana "
            ),
            h("i", { style: "color: teal" }, "")
          ]),
          duration: 0,
          type: "warning"
        });
      }

      if (this.DialogTitle == "AutoMVs por calificar") {
        if (this.TableData.length != 0) {
          this.closeDialogSeller = false;
          valid4 = true;
          return true;
        }
      }

      if (valid4) {
        const h = this.$createElement;
        this.$notify({
          message: h("b", null, [
            h(
              "span",
              null,
              "Debes aprobar los AutoMVs para poder cerrar esta ventana "
            ),
            h("i", { style: "color: teal" }, "")
          ]),
          duration: 0,
          type: "warning"
        });
      }
    },
    /*validaUserClose2() {
      var validd = false;

      if (this.DialogTitle == "Contratos vencidos") {
        this.TableData.forEach(data => {
          if (
            //dataROL.Id == 25 &&
            data.CustomerServicesCode == this.currentUser.CustomerServiceExec_
          ) {
            this.closeDialogSeller = false;
            validd = true;
          }
        });
      }
      if (validd) {
        const h = this.$createElement;
        this.$notify({
          message: h("b", null, [
            h("span", null, "RENUEVE O CANCELE LOS CONTRATOS"),
            h("i", { style: "color: teal" }, " Para cerrar esta ventana")
          ]),
          duration: 0,
          type: "warning"
        });
      }
    },*/
    closeInternalRequestDrawer() {
      this.showDetail = false;
      this.showDetailRate = false;
    },

    async getFreshTask() {
      //console.log("nueva data")
      this.TableData = await getDelayedTasks(this, this.directionId);
    },
    changeDialogCloseable(RolId, data) {
      if (RolId === 37) {
        this.close = true;
        if (this.TableData.length != 0) {
          this.loading = false;
          this.closeDialogSeller = !this.loading;
          this.validaUserClose();
        }
      } else {
        if (data.length > 0) {
          if (this.TableData.length != 0) {
            this.loading = false;
            this.closeDialogSeller = !this.loading;
            this.validaUserClose();
          }
          setTimeout(() => {
            return (this.close = true);
          }, 1000 * 3 /* * 60 */);
        } else {
          this.loading = false;
        }
      }
    },
    async toExecute(id) {
      this.loading = true;
      await this.$http
        .post("/api/CashFlow/Executed", {
          RowDetailID: id
        })
        .then(async ({ data }) => {
          if (data == true) {
            this.$notify.success({
              duration: 5000,
              message: "Cuenta ejecutada correctamente",
              title: "Información",
              position: "top-left"
            });
            this.TableData = await GetExpiredAccsWithoutExecution(this);
            if (this.TableData.length == 0) {
              this.isVisible = false;
            }
            this.$emit("refresh" /*this.row.Id*/);
          }
        })
        .catch((error) => {
          this.$message.error("Error al consultar los Registros");
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async onChangePDSuccess() {
      this.loading = true;
      this.TableData = await GetExpiredAccsWithoutExecution(this);
      if (this.TableData.length == 0) {
        this.isVisible = false;
      }
      this.loading = false;
      this.$emit("refresh" /* this.row.Id*/);
    },
    async refresh() {
      this.loading = true;
      this.TableData = await GetExpiredAccsWithoutExecution(this);
      if (this.TableData.length == 0) {
        this.isVisible = false;
      }
      this.loading = false;
      this.$emit("refresh");
    },
    nextDialog() {
      this.$emit("nextDialog");
    },

    handleStatusToggle(/*selection, row*/) {
      this.saveButtonVisible = true;
      //row.Excetuted = row.Excetuted == false ? true : false;
    },

    async updateProjectDetailLine() {
      //Actualiza la data de una linea de un proyecto.
      this.SaveButtonLoading = true;
      await this.$http
        .put("/api/Proyects/UpdateLine", this.TableData)
        .then(async (resp) => {
          if (resp.status == 200) {
            this.DetailDrawer = false;
            this.TableData = await GetProjectExpiredAccsWithoutExecution(this);
            if (this.TableData.length == 0) {
              this.isVisible = false;
            }
            this.$emit("refresh" /*this.row.Id*/);
          } else {
            this.$message({
              type: "error",
              message: "Error al actualizar registro"
            });
          }
        })
        .finally(() => {
          this.SaveButtonLoading = false;
          this.saveButtonVisible = false;
        });
    },
    changeProjectLineDate(row) {
      this.updatedLine = row;
      this.changeDateDiaglog = true;
    },

    async updateLine() {
      let projectLine = [];
      projectLine.push(this.updatedLine);
      this.SaveButtonLoading = true;
      await this.$http
        .put("/api/Proyects/UpdateLine", projectLine)
        .then(async (resp) => {
          if (resp.status == 200) {
            this.changeDateDiaglog = false;
            this.DetailDrawer = false;
            this.TableData = await GetProjectExpiredAccsWithoutExecution(this);
            if (this.TableData.length == 0) {
              this.isVisible = false;
            }
            this.$emit("refresh" /*this.row.Id*/);
          } else {
            this.$message({
              type: "error",
              message: "Error al actualizar registro"
            });
          }
        })
        .finally(() => {
          this.SaveButtonLoading = false;
        });
    },
    OpenContactsDetail(row, type) {
      this.$refs.AppCostumerServiceDetail.show(row, type);
    },
    handleCustomerServiceChange(val) {
      //console.log("CustomerServiceChange: ",val);
      if (val.length > 0) {
        this.customerServiceSelected = val[0].id;
      } else {
        this.customerServiceSelected = "";
      }
    },
    async fecthCustomers() {
      //this.Customeritems = [];
      this.loading = true;
      await this.$http
        .get("/api/customers", {
          timeout: 3 * 60 * 1000,
          params: {
            Page: this.page,
            Limit: this.limit,
            CompanyId: this.currentCompany,
            SalesPersonCode: this.seller_filter,
            Name: this.CustomerSearch,
            CustomerService: this.customers_filter,
            Contract: this.status_filter,
            AccountReceivable: this.cxc_filter,
            clasificaction: this.customer_clasification.value,
            ClientType: this.customer_type
          }
        })
        .then((resp) => {
          const { Items, ItemCount, CurrentPage } = resp.data;
          //console.log("fecthCustomers filterList resp: ", resp.data);
          this.CustomersList = Items;
          //this.filterList = Items;
          this.totalItems = ItemCount;
          this.page = CurrentPage;
        })
        .catch((error) => {
          //this.filterList = [];
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async OnFormsubmitted() {
      //console.log("Putazos");
      this.Formsubmitted = true;

      /*
      console.log(
        "entre a cancelacion de contratos NoContrato: ",
        this.currentActionData.row.NoContrato
      );
      */

      //let clientCode = "CL999999";

      /*
      let params = {
          "contractNumber" : this.currentActionData.row.NoContrato

      };
      */
      this.$http
        .post(
          "/api/contracts/CloseContract" +
            `?contractNumber=${this.currentActionData.row.NoContrato}&StatusContract=${this.StatusContract}`
        )
        .then((resp) => {
          resp;
          //console.log("respuesta de contrato cerrado: ", resp);
        })
        .catch((err) => {
          console.error("errado de contrato cerrado: ", err);
        })
        .finally(() => {
          this.GetDetailsData();
        });

      this.InactivateNavixyUser(this.currentActionData.row.ClientCode);
    },
    async InactivateNavixyUser(clientCode) {
      //console.log("ClientCode en InactivateNavixyUser: ", clientCode);
      /*
                "entre a cancelacion de contratos: ",
                this.currentActionData,
                "\n UserList: ",
                this.UserList,
                "\n getUserList: ",
                await this.getUserList,
                "\n NewUserList: ",
                this.UserList,

                "\n filteredUserList: ",
                this.UserList.filter(
                  (user) => user.post_region === this.currentActionData.row.ClientCode
                ),

                "\n getActualhash: ",
                this.getActualhash,
                "\n ObtainActualUserList: ",
                await this.ObtainActualUserList,
                "\n getActualUserList: ",
                this.getActualUserList(clientCode),
                */
      /*
      console.log(
        "\n ObtainActualUserInfo: ",

        await this.UpdateNavixyUser(clientCode, this)
      );
      */
      //let self = this;
      let udated = await this.UpdateNavixyUser(
        clientCode,
        this.callbackUserNoFound /*, self*/
      );
      console.log("updated final: ", udated);
      if (udated === true) {
        this.$message({
          showClose: true,
          message: "Se ha inhabilitado el usuario en navixy correctamente",
          type: "success"
        });
      } else {
        this.$message({
          showClose: true,
          message: "ha ocurrido un error al inhabilitar el usuario en navixy",
          type: "danger"
        });
      }
    },
    callbackUserNoFound(/*err*/) {
      //console.log ("Error no found in Database: ", err)
    },
    async onContractCancelationConfirmation(statusContract, action) {
      let CurrentClient;
      this.StatusContract = statusContract;
      this.ConfimrContractCancelView = false;
      //this.isCancelationConfirmed =
      this.$message({
        type: "info",
        message: `Procedemos con el con la solicitud de desinstalacion del contrato: #${action.row.NoContrato}`
      });

      await this.fecthCustomers();
      await this.CustomersList;
      CurrentClient = this.CustomersList.filter(
        (Cust) => Cust.ClientCode === action.row.ClientCode
      )[0];
      /*
              console.log(
                "CustomersList: ",
                this.CustomersList,
                "\nAction row: ",
                action.row,
                "\nCurrent client: ",
                CurrentClient
              );
              */
      //console.log("legue aqui klk action : ", action)
      //console.log("CurrentClient: ", CurrentClient)
      await this.$refs.dialogNewRequestForContractCancelation.show(
        action.row.ClientCode,
        CurrentClient
      );
    },
    OnContractCancelationClose(val, action, fromCancel) {
      this.ConfimrContractCancelView = val;

      //this.isCancelationConfirmed = false
      if (fromCancel) {
        this.$message({
          type: "info",
          message: `Cierre del contrato: #${action.row.NoContrato} Cancelado`
        });
      }
    },
    handler_year(_year) {
      this.year = _year;
    },

    handler_month(_month) {
      this.month = _month;
    }

    // updateTableData() {
    //   console.log("HELP!!!");
    // }
  },
  watch: {
    TableData(data) {
      //console.log("TableData(data): ", data);
      this.validaUserClose();
      if (this.TableData.length != 0) {
        this.closeDialogSeller = !this.loading;
      }
      //this.validaUserClose2();
      const weekday = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];

      const d = new Date(2022, 9, 25);
      let actualDate = weekday[d.getDay()];
      /*
      console.log(
        "actualDate: ",
        actualDate,
        "getDay():",
        d.getDay(),
        "fecha: ",
        d
      );
      */
      let RolId = this.currentUser.Roles.filter((r) => r.Id === 37).map(
        (x) => x.Id
      )[0];

      let UserId = this.currentUser.UserID;
      //console.log("RolId: ", RolId);

      switch (this.DialogTitle) {
        case "Tareas por aprobar":
          if (
            /*
            (actualDate === "Thursday" || actualDate === "Friday") &&
            // RolId !== 37 &&*/
            UserId !== 10
          ) {
            this.close = false;
            if (this.TableData.length != 0) {
              this.loading = false;
              this.closeDialogSeller = !this.loading;
              this.validaUserClose();
            }
          } else {
            this.changeDialogCloseable(RolId, data);
          }
          break;
        case "Tareas retrasadas": {
          if (
            (actualDate === "Friday" || actualDate === "Monday") &&
            /*RolId !== 37 &&*/ UserId !== 10
          ) {
            this.close = false;
            if (this.TableData.length != 0) {
              this.loading = false;
              this.closeDialogSeller = !this.loading;
              this.validaUserClose();
            }
          } else {
            this.changeDialogCloseable(RolId, data);
          }

          break;
        }
        case "Solicitudes nuevas pendientes por asignar": {
          if (
            (actualDate === "Thursday" || actualDate === "Friday") &&
            //RolId !== 37 &&
            UserId !== 10
          ) {
            this.close = false;
            if (this.TableData.length != 0) {
              this.loading = false;
              this.closeDialogSeller = !this.loading;
              this.validaUserClose();
            }
          } else {
            this.changeDialogCloseable(RolId, data);
          }
          break;
        }

        case "Solicitudes por calificar": {
          if (
            data.some(
              (request) =>
                request.CustomerServiceCode ===
                  this.currentUser.CustomerServiceExec_ &&
                request.PendingToRateDays > 0
            ) &&
            //RolId !== 37 &&
            UserId !== 10
          ) {
            this.close = false;
            if (this.TableData.length != 0) {
              this.loading = false;
              this.closeDialogSeller = !this.loading;
              this.validaUserClose();
            }
          } else {
            this.changeDialogCloseable(RolId, data);
          }
          break;
        }

        case "AutoMVs por calificar": {
          this.close = false;
          if (this.TableData.length != 0) {
            this.loading = false;
            this.closeDialogSeller = !this.loading;
            this.validaUserClose();
          } else {
            this.changeDialogCloseable(RolId, data);
          }
          break;
        }

        case "Solicitudes vencidas": {
          this.close = false;
          if (this.TableData.length != 0) {
            this.loading = false;
            this.closeDialogSeller = !this.loading;
            this.validaUserClose();
          } else {
            this.changeDialogCloseable(RolId, data);
          }
          break;
        }
        case "Cuentas vencidas del Cashflow General sin ejecutar": {
          this.close = false;
          if (
            this.currentUser.Roles.some((rol) => {
              return rol.Id === 32;
            }) &&
            UserId !== 10
          ) {
            if (this.TableData.length != 0) {
              // console.log("hola putos");
              this.loading = false;
              this.closeDialogSeller = false;
              //this.validaUserClose();
            }
          } else {
            this.changeDialogCloseable(RolId, data);
          }
          break;
        }

        case "Cuentas vencidas del Cashflow de Proyectos sin ejecutar": {
          this.close = false;
          if (
            this.currentUser.Roles.some((rol) => {
              return rol.Id === 30;
            }) &&
            UserId !== 10
          ) {
            if (this.TableData.length != 0) {
              // console.log("hola putos");
              this.loading = false;
              this.closeDialogSeller = false;
              //this.validaUserClose();
            }
          } else {
            this.changeDialogCloseable(RolId, data);
          }
          break;
        }
        case "Facturas del mes sin registrar": {
          this.close = false;
          if (this.TableData.length != 0) {
            this.loading = false;
            this.closeDialogSeller = !this.loading;
            this.validaUserClose();
          } else {
            this.changeDialogCloseable(RolId, data);
          }
          break;
        }
        case "Facturas sin registrar meses anteriores": {
          this.close = false;
          if (this.TableData.length != 0) {
            this.loading = false;
            this.closeDialogSeller = !this.loading;
            this.validaUserClose();
          } else {
            this.changeDialogCloseable(RolId, data);
          }
          break;
        }
        case "Pagos del mes sin realizar": {
          this.close = false;
          if (this.TableData.length != 0) {
            this.loading = false;
            this.closeDialogSeller = !this.loading;
            this.validaUserClose();
          } else {
            this.changeDialogCloseable(RolId, data);
          }
          break;
        }
        case "Pagos pendientes meses anteriores": {
          this.close = false;
          if (this.TableData.length != 0) {
            this.loading = false;
            this.closeDialogSeller = !this.loading;
            this.validaUserClose();
          } else {
            this.changeDialogCloseable(RolId, data);
          }
          break;
        }

        case "Encuestas": {
          this.close = false;
          this.closeDialogSeller = false;
          if (this.TableData.length != 0) {
            this.loading = false;
            this.validaUserClose();
            // this.encuestaUrlBase = "http://localhost:4200";
            this.encuestaUrlBase = "https://encuesta.tennosbusiness.net";
            // this.encuestalink = `http://localhost:4200/${this.TableData[0]}/${this.currentUser.UserID}`;
            this.encuestalink = `${this.encuestaUrlBase}/${this.TableData[0]}/${this.currentUser.UserID}`;
          } else {
            this.changeDialogCloseable(RolId, data);
          }
          break;
        }
        case "Documentos de clientes":
          this.close = false;
          this.closeDialogSeller = false;
          if (this.TableData.length != 0) {
            this.loading = false;
            this.closeDialogSeller = !this.loading;
            this.validaUserClose();
          } else {
            this.changeDialogCloseable(RolId, data);
          }
          break;
        // case "Pagos vencidos": {
        //   this.close = false;
        //   if (this.TableData.length != 0) {
        //     this.loading = false;
        //     this.closeDialogSeller = !this.loading;
        //     this.validaUserClose();
        //   } else {
        //     this.changeDialogCloseable(RolId, data);
        //   }
        //   break;
        // }

        default: {
          this.changeDialogCloseable(RolId, data);
        }
      }
    },
    dialog() {
      //console.log("Se esta actualizando el dialogo: ", dialogo);
    },
    TableLoading(val) {
      this.loading = val;
    }
  }
};
</script>

<style>
.title-container {
  text-transform: uppercase;
  font-size: 22px;
  font-weight: 700;
}
.el-dialog__header {
  background-color: #f3f7fa;
  border-bottom: 1px solid #72767b;
}
.collectionsFilter {
  float: right;
  margin-left: 0%;
}
.collectionsFilterToltip {
  padding-left: 0%;
}
.rowHeader {
  margin-top: 0%;
  margin-bottom: 0%;
  padding: 0%;
  font-size: 16px;
}
.internalRowHeader {
  margin-bottom: 0%;
}

.marginRight {
  margin-right: 5px;
}
</style>
